import Effect, { EFFECT } from './model/Effect';

export const EFFECT_STARS_AMOUNT = {
    [ EFFECT.ATTACK ]: [ 4, 5, 6 ],
    [ EFFECT.IDOL ]: [ 2, 3, 4 ],
    [ EFFECT.INSEPARABLE ]: [ 7, 8, 9 ],
    [ EFFECT.MUTANT_AGENDA ]: [ 8, 10, 12 ],
    [ EFFECT.COSMIC_SUPREMACY ]: [ 15, 25, 30 ],
    [ EFFECT.CRITICAL_RATE ]: [ 5, 6, 7 ],
    [ EFFECT.CRITICAL_DAMAGE ]: [ 15, 20, 25 ],
    [ EFFECT.BLEED ]: [ 15, 20, 25 ],
    [ EFFECT.COMBO ]: [ 5, 10, 15 ],
    [ EFFECT.LEGAL_DEFENSE ]: [ 5, 10, 15 ],
    [ EFFECT.STUN_SPECIAL ]: [ 15, 20, 25 ],
    [ EFFECT.POWER_GAIN ]: [ 3, 4, 5 ],
    [ EFFECT.ITS_COMPLICATED ]: [ 1, 2, 3 ],
    [ EFFECT.PERFECT_BLOCK ]: [ 3, 4, 5 ],
    [ EFFECT.ARMOR ]: [ 5, 6, 7 ],
    [ EFFECT.HEALTH ]: [ 4, 5, 6 ],
    [ EFFECT.HEROES_FOR_HIRE ]: [ 3, 4, 5 ],
    [ EFFECT.THUNDERBOLTS ]: [ 4, 5, 6 ],
    [ EFFECT.MASTERMINDS ]: [ 5, 10, 15 ],
    [ EFFECT.SHIELD_AGENTS ]: [ 10, 12, 15 ],
    [ EFFECT.SHIELD_CLEARANCE ]: [ 10, 12, 15 ],
    [ EFFECT.SHARED_GENETIC_MEMORY ]: [ 10, 12, 15 ],
    [ EFFECT.DEMON_HUNTER ]: [ 10, 12, 15 ],
    [ EFFECT.SPIRIT_OF_JUSTICE ]: [ 10, 12, 15 ],
    [ EFFECT.HEIGHTENED_SENSES ]: [ 10, 12, 15 ],
    [ EFFECT.COMPETITION ]: [ 10, 12, 15 ],
    [ EFFECT.BANE_OF_HELLS_KITCHEN ]: [ 10, 12, 15 ],
    [ EFFECT.DEFENDERS_DESTROYER ]: [ 10, 12, 15 ],
    [ EFFECT.SPLIT_PERSONALITY ]: [ 10, 12, 15 ],
    [ EFFECT.ELECTRIC_SUPERCHARGE ]: [ 10, 12, 15 ],
    [ EFFECT.SEETHING_HATRED ]: [ 10, 12, 15 ],
    [ EFFECT.PARTICLE_PHYSICS ]: [ 10, 12, 15 ],
    [ EFFECT.ENGINEERING ]: [ 10, 12, 15 ],
    [ EFFECT.BIOCHEMISTRY ]: [ 10, 12, 15 ],
    [ EFFECT.AVENGERS_TRYOUT ]: [ 10, 12, 15 ],
    [ EFFECT.CONTEST_NOOBS ]: [ 10, 12, 15 ],
    [ EFFECT.KNOWLEDGE_SHARE ]: [ 10, 12, 15 ],
    [ EFFECT.MASTERS_OF_THE_SWORD ]: [ 10, 12, 15 ],
    [ EFFECT.SOUL_SEEKER ]: [ 10, 12, 15 ],
    [ EFFECT.WARRIOR_QUEENS ]: [ 10, 12, 15 ],
    [ EFFECT.LOYAL_MINISTER ]: [ 10, 12, 15 ],
    [ EFFECT.CROSS_TRAINING ]: [ 10, 12, 15 ],
    [ EFFECT.BELIEVER ]: [ 10, 12, 15 ],
    [ EFFECT.TEAM_BUILDING_EXERCISE ]: [ 10, 12, 15 ],
    [ EFFECT.LULLABY ]: [ 10, 12, 15 ],
    [ EFFECT.OFF_LIMITS ]: [ 10, 12, 15 ],
    [ EFFECT.PUNY_GOD ]: [ 10, 12, 15 ],
    [ EFFECT.OVERCOMING_FEAR ]: [ 10, 12, 15 ],
    [ EFFECT.LIKE_OLD_DAYS ]: [ 10, 12, 15 ],
    [ EFFECT.NOT_AFRAID_OF_DEATH ]: [ 10, 12, 15 ],
    [ EFFECT.FRIEND_FROM_WORK ]: [ 10, 12, 15 ],
    [ EFFECT.ADVANCED_IDEA_MECHANICS ]: [ 10, 12, 15 ],
    [ EFFECT.CHAIR_LARCENY ]: [ 10, 12, 15 ],
    [ EFFECT.IMMORTAL_SOULS ]: [ 10, 12, 15 ],
    [ EFFECT.QUEEN_OF_HEL ]: [ 10, 12, 15 ],
    [ EFFECT.HELL_LORDS ]: [ 10, 12, 15 ],
    [ EFFECT.CUBICLE_MATES ]: [ 10, 12, 15 ],
    [ EFFECT.OTHER_HALF ]: [ 10, 12, 15 ],
    [ EFFECT.TERMINATION_CONTRACT ]: [ 10, 12, 15 ],
    [ EFFECT.PROFESSORS_IN_CRIME ]: [ 10, 12, 15 ],
    [ EFFECT.MOSTLY_AVERAGE_JOES ]: [ 10, 12, 15 ],
    [ EFFECT.THUNDER ]: [ 10, 12, 15 ],
    [ EFFECT.TEAM_DEADPOOL_AWESOME_FORCE ]: [ 10, 12, 15 ],
    [ EFFECT.BROKEN_MINDS ]: [ 10, 12, 15 ],
    [ EFFECT.ANNOYANCES_ASSEMBLE ]: [ 10, 12, 15 ],
    [ EFFECT.SIX_PACK ]: [ 10, 12, 15 ],
    [ EFFECT.XFORCE ]: [ 10, 12, 15 ],
    [ EFFECT.WEAPON_X_STRIKE_TEAM ]: [ 10, 12, 15 ],
    [ EFFECT.CODE_RED_REVELATIONS ]: [ 10, 12, 15 ],
    [ EFFECT.MERCS_FOR_MONEY ]: [ 10, 12, 15 ],
    [ EFFECT.BETTER_LUCK_NEXT_TIME ]: [ 10, 12, 15 ],
    [ EFFECT.COMPLICATED ]: [ 10, 12, 15 ],
    [ EFFECT.ESOTERIC_INSIGHT ]: [ 10, 12, 15 ],
    [ EFFECT.COVERT_INSIGHT ]: [ 10, 12, 15 ],
    [ EFFECT.FAMILIAR_INSIGHT ]: [ 10, 12, 15 ],
    [ EFFECT.AI_UPGRADE ]: [ 10, 12, 15 ],
    [ EFFECT.WAKANDAN_INSIGHT ]: [ 10, 12, 15 ],
    [ EFFECT.ENHANCED_SOLDIERS ]: [ 10, 12, 15 ],
    [ EFFECT.WAKANDA_LEADERSHIP ]: [ 10, 12, 15 ],
    [ EFFECT.FEARLESS ]: [ 10, 12, 15 ],
    [ EFFECT.MUTANT_PURSUIT ]: [ 10, 12, 15 ],
    [ EFFECT.SKILL_TRAINING ]: [ 10, 12, 15 ],
    [ EFFECT.SCIENCE_RESEARCH ]: [ 10, 12, 15 ],
    [ EFFECT.MYSTIC_OBSERVATION ]: [ 10, 12, 15 ],
    [ EFFECT.TECH_ADVANCEMENT ]: [ 10, 12, 15 ],
    [ EFFECT.CHRONAL_ANCHOR ]: [ 10, 12, 15 ],
    [ EFFECT.ENERGY_CONDUIT ]: [ 10, 12, 15 ],
    [ EFFECT.DEMONS ]: [ 10, 12, 15 ],
    [ EFFECT.PACT_WITH_A_DEMON ]: [ 10, 12, 15 ],
    [ EFFECT.INHUMAN_ROYAL_FAMILY ]: [ 10, 12, 15 ],
    [ EFFECT.INSPIRATION ]: [ 10, 12, 15 ],
    [ EFFECT.GET_IN_THE_POOL ]: [ 10, 12, 15 ],
    [ EFFECT.SPIRITUAL_STRENGTH ]: [ 10, 12, 15 ],
    [ EFFECT.PLAYING_WITH_FIRE ]: [ 10, 12, 15 ],
    [ EFFECT.TECH_BREAKTHROUGH ]: [ 10, 12, 15 ],
    [ EFFECT.MUTANT_EVOLUTION ]: [ 10, 12, 15 ],
    [ EFFECT.SKILL_TRAINING_CAIW ]: [ 10, 12, 15 ],
    [ EFFECT.SCIENCE_EXPERIMENT ]: [ 10, 12, 15 ],
    [ EFFECT.MYSTIC_CRAFT ]: [ 10, 12, 15 ],
    [ EFFECT.COSMIC_POWER ]: [ 10, 12, 15 ],
    [ EFFECT.ADVANCED_TECH ]: [ 10, 12, 15 ],
    [ EFFECT.HARD_TO_HIT ]: [ 10, 12, 15 ],
    [ EFFECT.DEADLY_STING ]: [ 10, 12, 15 ],
    [ EFFECT.UNTAMED_FORCE ]: [ 10, 12, 15 ],
    [ EFFECT.DECIMATION ]: [ 10, 12, 15 ],
    [ EFFECT.NO_MERCY ]: [ 10, 12, 15 ],
    [ EFFECT.FORMIDABLE_FOE ]: [ 10, 12, 15 ],
    [ EFFECT.MICROSCOPIC_OBSERVATION ]: [ 10, 12, 15 ],
    [ EFFECT.THE_UNTOUCHABLES ]: [ 10, 12, 15 ],
    [ EFFECT.UNMERCIFUL_PUNISHMENT ]: [ 10, 12, 15 ],
    [ EFFECT.ASGARDIAN_HUNT ]: [ 10, 12, 15 ],
    [ EFFECT.SPECIAL_ASSIST ]: [ 10, 12, 15 ],
    [ EFFECT.HUNT_THE_UNCANNY ]: [ 10, 12, 15 ],
    [ EFFECT.CHALLENGE_DEFENSES ]: [ 10, 12, 15 ],
    [ EFFECT.GRIPPED_BY_FEAR ]: [ 10, 12, 15 ],
    [ EFFECT.ENGULFED_BY_THE_VOID ]: [ 10, 12, 15 ],
    [ EFFECT.ENCHANTED_BLADES ]: [ 10, 12, 15 ],
    [ EFFECT.LOST_DAUGHTERS_OF_ASGARD ]: [ 10, 12, 15 ],
    [ EFFECT.WARRIORS_OF_ASGARD ]: [ 10, 12, 15 ],
    [ EFFECT.PIT_FIGHTERS ]: [ 10, 12, 15 ],
    [ EFFECT.GRANDMASTERS_CHAMPIONS ]: [ 10, 12, 15 ],
    [ EFFECT.ELEMENTAL_HIDE ]: [ 10, 12, 15 ],
    [ EFFECT.DARK_ILLUMINATI ]: [ 10, 12, 15 ],
    [ EFFECT.ETERNAL_ADVERSARIES ]: [ 10, 12, 15 ],
    [ EFFECT.HAIL_HYDRA ]: [ 10, 12, 15 ],
    [ EFFECT.DARK_EMPOWERMENT ]: [ 10, 12, 15 ],
    [ EFFECT.METAL_MAYHEM ]: [ 10, 12, 15 ],
    [ EFFECT.XASSASSINS ]: [ 10, 12, 15 ],
    [ EFFECT.SEEING_RED ]: [ 10, 12, 15 ],
    [ EFFECT.DEADLY_PRESENCE ]: [ 10, 12, 15 ],
    [ EFFECT.MEMORIES_OF_GENOSHA ]: [ 10, 12, 15 ],
    [ EFFECT.IMPENETRABLE_HIDE ]: [ 10, 12, 15 ],
    [ EFFECT.ITS_COMPLICATED_2 ]: [ 10, 12, 15 ],
    [ EFFECT.PHOENIX_FORCE ]: [ 10, 12, 15 ],
    [ EFFECT.TOUGH_BRAWLERS ]: [ 10, 12, 15 ],
    [ EFFECT.PERSISTENT_FORCE ]: [ 10, 12, 15 ],
    [ EFFECT.COMBO_FIGHTER ]: [ 10, 12, 15 ],
    [ EFFECT.DAVID_AND_GOLIATH ]: [ 10, 12, 15 ],
    [ EFFECT.COMBO_BREAKERS ]: [ 10, 12, 15 ],
    [ EFFECT.WARRIORS_OF_THE_STARS ]: [ 10, 12, 15 ],
    [ EFFECT.FRIENDS ]: [ 10, 12, 15 ],
    [ EFFECT.SCHOOL_OF_HARD_ROCKS ]: [ 10, 12, 15 ],
    [ EFFECT.WORTHY_OPPONENT ]: [ 10, 12, 15 ],
    [ EFFECT.UNENDING_AMBITION ]: [ 10, 12, 15 ],
    [ EFFECT.MADCAP_EXPERIMENTALISTS ]: [ 10, 12, 15 ],
    [ EFFECT.TWISTED_ARCANISTS ]: [ 10, 12, 15 ],
    [ EFFECT.LEGION_ACCURSED ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_BARRIER ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_SURVIVAL ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_REGENESIS ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_EVOLUTION ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_HIVE_MIND ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_AGGRESSION ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_PROBABILITY ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_RECODE_BLOODLETTING ]: [ 10, 12, 15 ],
    [ EFFECT.MYSTIC_MASTERS ]: [ 10, 12, 15 ],
    [ EFFECT.ANCIENT_HUNGER ]: [ 10, 12, 15 ],
    [ EFFECT.SUPREME_SYMBIOSIS ]: [ 10, 12, 15 ],
    [ EFFECT.MIDNIGHT_PURSUIT ]: [ 10, 12, 15 ],
    [ EFFECT.JUSTICE_ON_WHEELS ]: [ 10, 12, 15 ],
    [ EFFECT.CONTEST_TEAMMATES ]: [ 10, 12, 15 ],
    [ EFFECT.TACTICAL_TRAINING ]: [ 10, 12, 15 ],
    [ EFFECT.NIGHT_HAWKS ]: [ 10, 12, 15 ],
    [ EFFECT.DARK_JUSTICE ]: [ 10, 12, 15 ],
    [ EFFECT.BIRDS_OF_PREY ]: [ 10, 12, 15 ],
    [ EFFECT.RUNS_IN_THE_FAMILY ]: [ 10, 12, 15 ],
    [ EFFECT.OLD_TEAMMATES ]: [ 10, 12, 15 ],
    [ EFFECT.UNCANNY_AVENGERS ]: [ 10, 12, 15 ],
    [ EFFECT.GENETIC_MASTERPIECE ]: [ 10, 12, 15 ],
    [ EFFECT.MUTANT_DOMINION ]: [ 10, 12, 15 ],
    [ EFFECT.BLOOD_LINES ]: [ 10, 12, 15 ],
    [ EFFECT.MASTERMINDS_TWO ]: [ 10, 12, 15 ],
    [ EFFECT.STOLEN_MEMORIES ]: [ 10, 12, 15 ],
    [ EFFECT.PARTNERS_IN_SHIELD ]: [ 10, 12, 15 ],
    [ EFFECT.MARVELOUS ]: [ 10, 12, 15 ],
    [ EFFECT.FAN_CLUB ]: [ 10, 12, 15 ],
    [ EFFECT.RESTORATION_KIT ]: [ 10, 12, 15 ],
    [ EFFECT.STRATEGIC_SABOTAGE ]: [ 10, 12, 15 ],
    [ EFFECT.INCREASED_FIREPOWER ]: [ 10, 12, 15 ],
    [ EFFECT.CONTINGENCY_PLAN ]: [ 10, 12, 15 ],
    [ EFFECT.EXTREME_CONDITIONS_KIT ]: [ 10, 12, 15 ],
    [ EFFECT.POWER_KIT ]: [ 10, 12, 15 ],
    [ EFFECT.GWENOM_RISING ]: [ 10, 12, 15 ],
    [ EFFECT.AGENTS_OF_SMASH ]: [ 10, 12, 15 ],
    [ EFFECT.HUNTRESS_OF_THE_CONTEST ]: [ 10, 12, 15 ],
    [ EFFECT.SIBLING_RIVALRY ]: [ 10, 12, 15 ],
    [ EFFECT.CYBERNETICS_UPGRADE_ASSAULT ]: [ 10, 12, 15 ],
    [ EFFECT.CYBERNETICS_UPGRADE_TACTICS ]: [ 10, 12, 15 ],
    [ EFFECT.DOUBLE_NEGATIVE ]: [ 10, 12, 15 ],
    [ EFFECT.CHALLENGER ]: [ 10, 12, 15 ],
    [ EFFECT.RAIN_OF_FIRE ]: [ 10, 12, 15 ],
    [ EFFECT.TURN_UP_THE_HEAT ]: [ 10, 12, 15 ],
    [ EFFECT.A_SONG_OF_FIRE_AND_ICE ]: [ 10, 12, 15 ],
    [ EFFECT.FAMILIAR_FACES ]: [ 10, 12, 15 ],
    [ EFFECT.LAST_HOPE ]: [ 10, 12, 15 ],
    [ EFFECT.UNLIKELY_COMBINATION ]: [ 10, 12, 15 ],
    [ EFFECT.LIVE_AND_DIE_BY_THE_SWORD ]: [ 10, 12, 15 ],
    [ EFFECT.MASTERLESS ]: [ 10, 12, 15 ],
    [ EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER ]: [ 10, 12, 15 ],
    [ EFFECT.CULL_OF_THE_MAW ]: [ 10, 12, 15 ],
    [ EFFECT.INVASIVE_FORCE ]: [ 10, 12, 15 ],
    [ EFFECT.DISPLAY_OF_STRENGTH ]: [ 10, 12, 15 ],
    [ EFFECT.HEROES_NEVER_LEARN ]: [ 10, 12, 15 ],
    [ EFFECT.TIDE_TO_GO ]: [ 10, 12, 15 ],
    [ EFFECT.KINGS_OF_THE_WORLD ]: [ 10, 12, 15 ],
    [ EFFECT.BEACH_BODS ]: [ 10, 12, 15 ],
    [ EFFECT.FORCE_BLOCK ]: [ 10, 12, 15 ],
    [ EFFECT.TILL_DEATH ]: [ 10, 12, 15 ],
    [ EFFECT.UNPHASED ]: [ 10, 12, 15 ],
    [ EFFECT.ONE_WAY_OR_ANOTHER ]: [ 10, 12, 15 ],
    [ EFFECT.STARK_INTERNSHIP ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERMEN_IN_BLACK ]: [ 10, 12, 15 ],
    [ EFFECT.BAD_FOR_BUSINESS ]: [ 10, 12, 15 ],
    [ EFFECT.CULTURE_SHOCK ]: [ 10, 12, 15 ],
    [ EFFECT.MINE_CAN_HOVER ]: [ 10, 12, 15 ],
    [ EFFECT.ENCROACHING_INSANITY ]: [ 10, 12, 15 ],
    [ EFFECT.ENHANCED_ILLUSIONIST ]: [ 10, 12, 15 ],
    [ EFFECT.MENTAL_IMMUNITY ]: [ 10, 12, 15 ],
    [ EFFECT.NEW_MUTANTS ]: [ 10, 12, 15 ],
    [ EFFECT.AIM_TECHNOLOGY ]: [ 10, 12, 15 ],
    [ EFFECT.LEADING_AVENGERS ]: [ 10, 12, 15 ],
    [ EFFECT.SELFFRIENDS ]: [ 10, 12, 15 ],
    [ EFFECT.ROBOT_UPRISING ]: [ 10, 12, 15 ],
    [ EFFECT.GOING_VIRAL ]: [ 10, 12, 15 ],
    [ EFFECT.FIRST_OF_HIS_NAME ]: [ 10, 12, 15 ],
    [ EFFECT.DRY_ICE ]: [ 10, 12, 15 ],
    [ EFFECT.SENIORS_DISCOUNT ]: [ 10, 12, 15 ],
    [ EFFECT.JUDGEMENT_DAY ]: [ 10, 12, 15 ],
    [ EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY ]: [ 10, 12, 15 ],
    [ EFFECT.FIRE_AND_FORGET ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERS_BITE ]: [ 10, 12, 15 ],
    [ EFFECT.FEARSOME_FOUR ]: [ 10, 12, 15 ],
    [ EFFECT.BANE_OF_EVIL ]: [ 10, 12, 15 ],
    [ EFFECT.THINGS ]: [ 10, 12, 15 ],
    [ EFFECT.MISUNDERSTOOD_MONSTERS ]: [ 10, 12, 15 ],
    [ EFFECT.AI_UPRISING ]: [ 10, 12, 15 ],
    [ EFFECT.OUR_SHARED_CURSE ]: [ 10, 12, 15 ],
    [ EFFECT.HUNTING_PARTY ]: [ 10, 12, 15 ],
    [ EFFECT.BEAUTY_AND_THE_BEAST ]: [ 10, 12, 15 ],
    [ EFFECT.FANTASTIC_RAGE ]: [ 10, 12, 15 ],
    [ EFFECT.ENHANCED_FORCEFIELD ]: [ 10, 12, 15 ],
    [ EFFECT.GENIUS_INGENUITY ]: [ 10, 12, 15 ],
    [ EFFECT.SORCERY_REVERSAL ]: [ 10, 12, 15 ],
    [ EFFECT.COSMIC_OVERLOAD ]: [ 10, 12, 15 ],
    [ EFFECT.MYSTIC_TYRANTS ]: [ 10, 12, 15 ],
    [ EFFECT.HERBIE ]: [ 10, 12, 15 ],
    [ EFFECT.FANTASTIC_FOUR ]: [ 10, 12, 15 ],
    [ EFFECT.DO_US_PART ]: [ 10, 12, 15 ],
    [ EFFECT.COLLEGE_RIVALS ]: [ 10, 12, 15 ],
    [ EFFECT.SK_ASTRONOMY ]: [ 10, 12, 15 ],
    [ EFFECT.SK_ROBOTICS ]: [ 10, 12, 15 ],
    [ EFFECT.SK_GENETICS ]: [ 10, 12, 15 ],
    [ EFFECT.HERALDS_OF_GALACTUS ]: [ 10, 12, 15 ],
    [ EFFECT.SECRET_DEFENDERS ]: [ 10, 12, 15 ],
    [ EFFECT.MINE_TRAVELS_THROUGH_SPACE ]: [ 10, 12, 15 ],
    [ EFFECT.NEW_WARRIOR_BLOOD ]: [ 10, 12, 15 ],
    [ EFFECT.TOTAL_ANNIHILATION ]: [ 10, 12, 15 ],
    [ EFFECT.MAXIMUM_OUTPUT ]: [ 10, 12, 15 ],
    [ EFFECT.PHALANX_FEUD ]: [ 10, 12, 15 ],
    [ EFFECT.FULL_SPEED_AHEAD ]: [ 10, 12, 15 ],
    [ EFFECT.SUPERNANNY ]: [ 10, 12, 15 ],
    [ EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS ]: [ 10, 12, 15 ],
    [ EFFECT.HARDWIRED_FOR_HEARTBREAK ]: [ 10, 12, 15 ],
    [ EFFECT.BEAT_UP_THE_UNIVERSE ]: [ 10, 12, 15 ],
    [ EFFECT.MOJOVERSE ]: [ 10, 12, 15 ],
    [ EFFECT.SMILE_FOR_THE_CAMERAS ]: [ 10, 12, 15 ],
    [ EFFECT.WITHOUT_A_LEG_TO_STAND_ON ]: [ 10, 12, 15 ],
    [ EFFECT.CROWD_PLEASERS ]: [ 10, 12, 15 ],
    [ EFFECT.CIVIL_WAR_STORIES ]: [ 10, 12, 15 ],
    [ EFFECT.LOVE_TRIANGLES ]: [ 10, 12, 15 ],
    [ EFFECT.PROBABLY_OP ]: [ 10, 12, 15 ],
    [ EFFECT.GOOD_VIBRATIONS ]: [ 10, 12, 15 ],
    [ EFFECT.MONSTER_MASH ]: [ 10, 12, 15 ],
    [ EFFECT.FANTASTIC_FIENDS ]: [ 10, 12, 15 ],
    [ EFFECT.DEATH_AND_RESURRECTION ]: [ 10, 12, 15 ],
    [ EFFECT.ELDERS_GAME ]: [ 10, 12, 15 ],
    [ EFFECT.PRISONER ]: [ 10, 12, 15 ],
    [ EFFECT.A_GANG_OF ]: [ 10, 12, 15 ],
    [ EFFECT.LAB_PARTNERS ]: [ 10, 12, 15 ],
    [ EFFECT.TROPHY_CASE ]: [ 10, 12, 15 ],
    [ EFFECT.CHAMPIONS_OF_BATTLEWORLD ]: [ 10, 12, 15 ],
    [ EFFECT.DOCTORS_STRANGE ]: [ 10, 12, 15 ],
    [ EFFECT.MYSTIC_ARTS ]: [ 10, 12, 15 ],
    [ EFFECT.BLUETIFUL_PEOPLE ]: [ 10, 12, 15 ],
    [ EFFECT.GAMMA_HORDE ]: [ 10, 12, 15 ],
    [ EFFECT.HOUSE_OF_IRON ]: [ 10, 12, 15 ],
    [ EFFECT.SETUP_AND_SPIKE ]: [ 10, 12, 15 ],
    [ EFFECT.UNDER_THE_WEATHER ]: [ 10, 12, 15 ],
    [ EFFECT.KINGDOM_OF_WAKANDA ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERGUILD ]: [ 10, 12, 15 ],
    [ EFFECT.FAMILY_REUNION ]: [ 10, 12, 15 ],
    [ EFFECT.EASTERN_BLOCKERS ]: [ 10, 12, 15 ],
    [ EFFECT.LIVING_STEEL_CURTAIN ]: [ 10, 12, 15 ],
    [ EFFECT.MAGNIFICENT_MANES ]: [ 10, 12, 15 ],
    [ EFFECT.ENHANCED_WITH_CARBONADIUM ]: [ 10, 12, 15 ],
    [ EFFECT.REMEMBER_ME ]: [ 10, 12, 15 ],
    [ EFFECT.REMEMBERING_BUDAPEST ]: [ 10, 12, 15 ],
    [ EFFECT.COVERT_EXPERTISE ]: [ 10, 12, 15 ],
    [ EFFECT.WEST_COAST_AVENGERS ]: [ 10, 12, 15 ],
    [ EFFECT.FELINE_POSSESSION ]: [ 10, 12, 15 ],
    [ EFFECT.ENTREE ]: [ 10, 12, 15 ],
    [ EFFECT.BIG_GAME_HUNTERS ]: [ 10, 12, 15 ],
    [ EFFECT.NOT_THE_FACE ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDER_MONKEY ]: [ 10, 12, 15 ],
    [ EFFECT.FURRY_FRENEMIES ]: [ 10, 12, 15 ],
    [ EFFECT.NO_EVIL ]: [ 10, 12, 15 ],
    [ EFFECT.ON_GUARD_FOR_THEE ]: [ 10, 12, 15 ],
    [ EFFECT.ALPHA_FLIGHT ]: [ 10, 12, 15 ],
    [ EFFECT.EXCAVATORS ]: [ 10, 12, 15 ],
    [ EFFECT.JUST_HAIR_AND_THINGS ]: [ 10, 12, 15 ],
    [ EFFECT.GAMMA_RAY_RAY ]: [ 10, 12, 15 ],
    [ EFFECT.FURRY_BUDS ]: [ 10, 12, 15 ],
    [ EFFECT.GIANT_CHALLENGERS ]: [ 10, 12, 15 ],
    [ EFFECT.COMMON_HISTORY ]: [ 10, 12, 15 ],
    [ EFFECT.NOVA_CORPS_VETERANS ]: [ 10, 12, 15 ],
    [ EFFECT.THE_HIGH_GROUND ]: [ 10, 12, 15 ],
    [ EFFECT.THE_FIRST_ONE ]: [ 10, 12, 15 ],
    [ EFFECT.BRINGER_OF_DEATH_I ]: [ 10, 12, 15 ],
    [ EFFECT.BRINGER_OF_DEATH_II ]: [ 10, 12, 15 ],
    [ EFFECT.BRINGER_OF_DEATH_III ]: [ 10, 12, 15 ],
    [ EFFECT.BRINGER_OF_DEATH_IV ]: [ 10, 12, 15 ],
    [ EFFECT.GUARDIAN_OF_THE_PYRAMID ]: [ 10, 12, 15 ],
    [ EFFECT.IMPENDING_STORM ]: [ 10, 12, 15 ],
    [ EFFECT.YOUR_FATE_IS_MINE ]: [ 10, 12, 15 ],
    [ EFFECT.CHAOTIC_ENERGY ]: [ 10, 12, 15 ],
    [ EFFECT.CROSSOVER ]: [ 10, 12, 15 ],
    [ EFFECT.DEATHWISH ]: [ 10, 12, 15 ],
    [ EFFECT.GOODFELLA ]: [ 10, 12, 15 ],
    [ EFFECT.MERC_WITH_A_MOUTH ]: [ 10, 12, 15 ],
    [ EFFECT.STUCK_IN_LIMBO ]: [ 10, 12, 15 ],
    [ EFFECT.DRUG_I ]: [ 10, 12, 15 ],
    [ EFFECT.DRUG_L ]: [ 10, 12, 15 ],
    [ EFFECT.DRUG_M ]: [ 10, 12, 15 ],
    [ EFFECT.GATEWAY ]: [ 10, 12, 15 ],
    [ EFFECT.HABITAT ]: [ 10, 12, 15 ],
    [ EFFECT.FIRST_CRUSH ]: [ 10, 12, 15 ],
    [ EFFECT.FULL_METAL ]: [ 10, 12, 15 ],
    [ EFFECT.NOT_SO_HIDDEN_DRAGON ]: [ 10, 12, 15 ],
    [ EFFECT.STUDENT_LOANS ]: [ 10, 12, 15 ],
    [ EFFECT.MY_BROTHERHOOD ]: [ 10, 12, 15 ],
    [ EFFECT.MY_CONTEST_NOW ]: [ 10, 12, 15 ],
    [ EFFECT.MY_HELLFIRE_CLUB ]: [ 10, 12, 15 ],
    [ EFFECT.MY_METALLIC_ANTIPATHY ]: [ 10, 12, 15 ],
    [ EFFECT.METALLIC_AFFINITY ]: [ 10, 12, 15 ],
    [ EFFECT.REDEMPTION ]: [ 10, 12, 15 ],
    [ EFFECT.RISE_AGAINST_THE_CONTEST ]: [ 10, 12, 15 ],
    [ EFFECT.FAMILY_FEUD ]: [ 10, 12, 15 ],
    [ EFFECT.HATRED ]: [ 10, 12, 15 ],
    [ EFFECT.OSBORN_TO_BE_WILD ]: [ 10, 12, 15 ],
    [ EFFECT.SELF_CENTERED ]: [ 10, 12, 15 ],
    [ EFFECT.SYMBIOTE_CONSCIOUSNESS ]: [ 10, 12, 15 ],
    [ EFFECT.COSMIC_BANE_OF_EVIL ]: [ 10, 12, 15 ],
    [ EFFECT.COSMIC_JUSTICE_ON_WHEELS ]: [ 10, 12, 15 ],
    [ EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY ]: [ 10, 12, 15 ],
    [ EFFECT.SPIRITS_OF_VENGEANCE ]: [ 10, 12, 15 ],
    [ EFFECT.FASTBALL_SPECIAL ]: [ 10, 12, 15 ],
    [ EFFECT.FEEL_CYTORAKS_EMBRACE ]: [ 10, 12, 15 ],
    [ EFFECT.DONT_MENTION_PUNY_BANNER ]: [ 10, 12, 15 ],
    [ EFFECT.TECHNOLOGICAL_COMPETITION ]: [ 10, 12, 15 ],
    [ EFFECT.ENGINEERING_EXPERTS ]: [ 10, 12, 15 ],
    [ EFFECT.IT_AINT_EASY ]: [ 10, 12, 15 ],
    [ EFFECT.SINGULARITY ]: [ 10, 12, 15 ],
    [ EFFECT.ENHANCED_ADAMANTIUM ]: [ 10, 12, 15 ],
    [ EFFECT.NO_NOT_YOU ]: [ 10, 12, 15 ],
    [ EFFECT.THE_BRAVE_AND_THE_BOULDER ]: [ 10, 12, 15 ],
    [ EFFECT.PASSIVE_AGGRESSIVE ]: [ 10, 12, 15 ],
    [ EFFECT.ARACHNID_HUNTERS ]: [ 10, 12, 15 ],
    [ EFFECT.ALPHA_FLIGHT_SPACE_STATION ]: [ 10, 12, 15 ],
    [ EFFECT.GAMMA_MUTATES ]: [ 10, 12, 15 ],
    [ EFFECT.EXTREME_MEASURES ]: [ 10, 12, 15 ],
    [ EFFECT.HELL_AND_BACK ]: [ 10, 12, 15 ],
    [ EFFECT.FAIREST_OF_THEM_ALL ]: [ 10, 12, 15 ],
    [ EFFECT.ABOMINABLE_COMRADE ]: [ 10, 12, 15 ],
    [ EFFECT.IMMORTAL_RULERS ]: [ 10, 12, 15 ],
    [ EFFECT.IMMORTAL_KINGS ]: [ 10, 12, 15 ],
    [ EFFECT.TWO_DAYS_THIRTY_YEARS ]: [ 10, 12, 15 ],
    [ EFFECT.SATURDAY_MORNING_CARTOONS ]: [ 10, 12, 15 ],
    [ EFFECT.SWINESTER_SIX_MOST_WANTED ]: [ 10, 12, 15 ],
    [ EFFECT.FOURTH_WALL_CRAWLER ]: [ 10, 12, 15 ],
    [ EFFECT.FISK_DOWNFALL ]: [ 10, 12, 15 ],
    [ EFFECT.SECRET_OF_THE_HAND ]: [ 10, 12, 15 ],
    [ EFFECT.RULE_OF_LAW ]: [ 10, 12, 15 ],
    [ EFFECT.STRENGTH_OF_MARTYRS ]: [ 10, 12, 15 ],
    [ EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE ]: [ 10, 12, 15 ],
    [ EFFECT.DEAL_WITH_IT ]: [ 10, 12, 15 ],
    [ EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE ]: [ 10, 12, 15 ],
    [ EFFECT.PETITE ]: [ 10, 12, 15 ],
    [ EFFECT.THE_LUCKY_ONE ]: [ 10, 12, 15 ],
    [ EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN ]: [ 10, 12, 15 ],
    [ EFFECT.BIG_BAD_DAD ]: [ 10, 12, 15 ],
    [ EFFECT.BULL_TARGETS ]: [ 10, 12, 15 ],
    [ EFFECT.CLONED_AT_BIRTH ]: [ 10, 12, 15 ],
    [ EFFECT.MISS_ME ]: [ 10, 12, 15 ],
    [ EFFECT.HOSTILE_TAKEOVER ]: [ 10, 12, 15 ],
    [ EFFECT.WEDDING_CRASHER ]: [ 10, 12, 15 ],
    [ EFFECT.DINKY_SHRINKS ]: [ 10, 12, 15 ],
    [ EFFECT.MALICE ]: [ 10, 12, 15 ],
    [ EFFECT.PURE_HATRED ]: [ 10, 12, 15 ],
    [ EFFECT.THERE_GOES_THE_MULTIVERSE ]: [ 10, 12, 15 ],
    [ EFFECT.POWER_OF_MONEY ]: [ 10, 12, 15 ],
    [ EFFECT.REVOLUTIONS_NEED_ARMS ]: [ 10, 12, 15 ],
    [ EFFECT.AMBER_PRISON ]: [ 10, 12, 15 ],
    [ EFFECT.BANISHED ]: [ 10, 12, 15 ],
    [ EFFECT.ENERGY_ABSORPTION ]: [ 10, 12, 15 ],
    [ EFFECT.FUELED_WITH_RAGE ]: [ 10, 12, 15 ],
    [ EFFECT.RAGE_ON ]: [ 10, 12, 15 ],
    [ EFFECT.BATTLE_OF_REALMS ]: [ 10, 12, 15 ],
    [ EFFECT.OATHSWORN ]: [ 10, 12, 15 ],
    [ EFFECT.ODINSONS_AND_ODINSDOTTIRS ]: [ 10, 12, 15 ],
    [ EFFECT.WARMONGER ]: [ 10, 12, 15 ],
    [ EFFECT.HYDRA_RECRUITERS ]: [ 10, 12, 15 ],
    [ EFFECT.MERCENARY_COMPETITION ]: [ 10, 12, 15 ],
    [ EFFECT.CONTEMPTUOUS_HATRED ]: [ 10, 12, 15 ],
    [ EFFECT.WE_AINT_NO_PUNCHLINE ]: [ 10, 12, 15 ],
    [ EFFECT.NEW_YORK_BRAWLERS ]: [ 10, 12, 15 ],
    [ EFFECT.NOT_SO_UNCANNY ]: [ 10, 12, 15 ],
    [ EFFECT.IRON_MEN ]: [ 10, 12, 15 ],
    [ EFFECT.ASGARDIAN_REPUBLIC ]: [ 10, 12, 15 ],
    [ EFFECT.PATRIOT_GARRISON ]: [ 10, 12, 15 ],
    [ EFFECT.PET_PALS ]: [ 10, 12, 15 ],
    [ EFFECT.HUNTRESSES ]: [ 10, 12, 15 ],
    [ EFFECT.PYRAMID_X ]: [ 10, 12, 15 ],
    [ EFFECT.TEMPLE_OF_VISHANTI ]: [ 10, 12, 15 ],
    [ EFFECT.TRIBAL_WARFARE ]: [ 10, 12, 15 ],
    [ EFFECT.EYES_OF_THE_DRAGON ]: [ 10, 12, 15 ],
    [ EFFECT.MASTER_MARTIAL_ARTISTS ]: [ 10, 12, 15 ],
    [ EFFECT.SHADOWLAND ]: [ 10, 12, 15 ],
    [ EFFECT.THE_WAY_OF_THE_SPIDER ]: [ 10, 12, 15 ],
    [ EFFECT.A_BEING_DARKER_THAN_I ]: [ 10, 12, 15 ],
    [ EFFECT.FROM_LIGHT_TO_DARK ]: [ 10, 12, 15 ],
    [ EFFECT.HEALING_TOUCH ]: [ 10, 12, 15 ],
    [ EFFECT.TIME_WE_CHANGED_TOO ]: [ 10, 12, 15 ],
    [ EFFECT.BATTLEREALMS_CHANGING ]: [ 10, 12, 15 ],
    [ EFFECT.KINGS ]: [ 10, 12, 15 ],
    [ EFFECT.ROYALS ]: [ 10, 12, 15 ],
    [ EFFECT.WARRIORS ]: [ 10, 12, 15 ],
    [ EFFECT.DIMENSIONAL_BUDDIES ]: [ 10, 12, 15 ],
    [ EFFECT.MANY_AS_ONE ]: [ 10, 12, 15 ],
    [ EFFECT.POOR_UNFORTUNATE_SOUL ]: [ 10, 12, 15 ],
    [ EFFECT.QUEENS_OF_SOULS ]: [ 10, 12, 15 ],
    [ EFFECT.UNCHAINED ]: [ 10, 12, 15 ],
    [ EFFECT.WHAT_IF ]: [ 10, 12, 15 ],
    [ EFFECT.COSMIC_CONTROL ]: [ 10, 12, 15 ],
    [ EFFECT.CUBE_WIELDERS ]: [ 10, 12, 15 ],
    [ EFFECT.IDENTITY_DISORDER ]: [ 10, 12, 15 ],
    [ EFFECT.SHIELD_BUDDIES ]: [ 10, 12, 15 ],
    [ EFFECT.SPACE_SURFERS ]: [ 10, 12, 15 ],
    [ EFFECT.FORTIFY_ENHANCEMENT ]: [ 10, 12, 15 ],
    [ EFFECT.SKIRMISH_ENHANCEMENT ]: [ 10, 12, 15 ],
    [ EFFECT.SUPPORT_ENHANCEMENT ]: [ 10, 12, 15 ],
    [ EFFECT.MY_BEAUTIFUL_METEOR ]: [ 10, 12, 15 ],
    [ EFFECT.MY_WORLD_OF_METAL ]: [ 10, 12, 15 ],
    [ EFFECT.DECIMATION_SW ]: [ 10, 12, 15 ],
    [ EFFECT.CHAOS_RISING ]: [ 10, 12, 15 ],
    [ EFFECT.TILL_INFINITY_DO_US_PART ]: [ 10, 12, 15 ],
    [ EFFECT.DEMONIC_PACT ]: [ 10, 12, 15 ],
    [ EFFECT.SUPER_STARS ]: [ 10, 12, 15 ],
    [ EFFECT.OUT_OF_THIS_WORLD ]: [ 10, 12, 15 ],
    [ EFFECT.STAY_POSITIVE ]: [ 10, 12, 15 ],
    [ EFFECT.KO_QUEENS ]: [ 10, 12, 15 ],
    [ EFFECT.NEXT_ROUND_ON_ME ]: [ 10, 12, 15 ],
    [ EFFECT.MASTERFUL_COMBAT ]: [ 10, 12, 15 ],
    [ EFFECT.ARM_WRESTLING_CLUB ]: [ 10, 12, 15 ],
    [ EFFECT.PAWN_SET_FREE ]: [ 10, 12, 15 ],
    [ EFFECT.INCREDIBLE_SUBSTITUTE ]: [ 10, 12, 15 ],
    [ EFFECT.I_REQUIRE_THY_SHIELD ]: [ 10, 12, 15 ],
    [ EFFECT.START_WITH_FRESH_DEADPOOL ]: [ 10, 12, 15 ],
    [ EFFECT.ACCURATELY_MEASURE_INGREDIENTS ]: [ 10, 12, 15 ],
    [ EFFECT.BLEND_IN_SYMBIOTE ]: [ 10, 12, 15 ],
    [ EFFECT.ADD_PLAIN_WHITE_FLOUR ]: [ 10, 12, 15 ],
    [ EFFECT.FRY_IN_SKILLET ]: [ 10, 12, 15 ],
    [ EFFECT.ADJUST_COOKING_TIMER ]: [ 10, 12, 15 ],
    [ EFFECT.ALLOW_TO_COOL ]: [ 10, 12, 15 ],
    [ EFFECT.MUNCH_STUNNING_FOOD ]: [ 10, 12, 15 ],
    [ EFFECT.NOT_THE_HERO ]: [ 10, 12, 15 ],
    [ EFFECT.BUT_THE_BEST_VILLAIN ]: [ 10, 12, 15 ],
    [ EFFECT.CRIME_BOSSES ]: [ 10, 12, 15 ],
    [ EFFECT.CONTEMPTUOUS_MALICE ]: [ 10, 12, 15 ],
    [ EFFECT.GIANT_MONSTROSITIES ]: [ 10, 12, 15 ],
    [ EFFECT.ANGEL_ATTACK ]: [ 10, 12, 15 ],
    [ EFFECT.FIELD_TRIP ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERGEDDON ]: [ 10, 12, 15 ],
    [ EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES ]: [ 10, 12, 15 ],
    [ EFFECT.SUIT_UP ]: [ 10, 12, 15 ],
    [ EFFECT.TECHNICIAN ]: [ 10, 12, 15 ],
    [ EFFECT.AI_ENTHUSIASTS ]: [ 10, 12, 15 ],
    [ EFFECT.COWORKERS ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERVERSE_VETERANS ]: [ 10, 12, 15 ],
    [ EFFECT.SYMBIOTE_PROBLEMS ]: [ 10, 12, 15 ],
    [ EFFECT.WE_ARE_MANY ]: [ 10, 12, 15 ],
    [ EFFECT.ADVANCED_INTELLIGENCE ]: [ 10, 12, 15 ],
    // [ EFFECT.NEW_WAVE ]: [ 10, 12, 15 ],
    [ EFFECT.RESISTANCE_IS_FUTILE ]: [ 10, 12, 15 ],
    [ EFFECT.TERMINATED ]: [ 10, 12, 15 ],
    [ EFFECT.FIRE_AND_DRAGONS ]: [ 10, 12, 15 ],
    [ EFFECT.JUST_A_PHASE ]: [ 10, 12, 15 ],
    [ EFFECT.SHADOWY_HISTORY ]: [ 10, 12, 15 ],
    [ EFFECT.THROUGH_THICK_AND_THIN ]: [ 10, 12, 15 ],
    [ EFFECT.VICIOUS_KITTY ]: [ 10, 12, 15 ],
    [ EFFECT.WORTH_A_SHOT ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERSENSES_TINGLING ]: [ 10, 12, 15 ],
    [ EFFECT.SPIDERVERSE_MENTORS ]: [ 10, 12, 15 ],
    [ EFFECT.CYBERNETICS_UPGRADE_BLITZ ]: [ 10, 12, 15 ],
};
export const EFFECT_STARS_INDEX = { 1: 0, 2: 0, 3: 1, 4: 2, 5: 2 };

const effects = [

    { uid: EFFECT.ATTACK },
    { uid: EFFECT.IDOL },
    { uid: EFFECT.INSEPARABLE },
    { uid: EFFECT.MUTANT_AGENDA },
    { uid: EFFECT.COSMIC_SUPREMACY },
    { uid: EFFECT.CRITICAL_RATE },
    { uid: EFFECT.CRITICAL_DAMAGE },
    { uid: EFFECT.BLEED },
    { uid: EFFECT.COMBO },
    { uid: EFFECT.LEGAL_DEFENSE },
    { uid: EFFECT.STUN_SPECIAL },
    { uid: EFFECT.POWER_GAIN },
    { uid: EFFECT.ITS_COMPLICATED },
    { uid: EFFECT.PERFECT_BLOCK },
    { uid: EFFECT.ARMOR },
    { uid: EFFECT.HEALTH },
    { uid: EFFECT.HEROES_FOR_HIRE },
    { uid: EFFECT.THUNDERBOLTS },
    { uid: EFFECT.MASTERMINDS },
    { uid: EFFECT.SHIELD_AGENTS },
    { uid: EFFECT.SHIELD_CLEARANCE },
    { uid: EFFECT.SHARED_GENETIC_MEMORY },
    { uid: EFFECT.DEMON_HUNTER },
    { uid: EFFECT.SPIRIT_OF_JUSTICE },
    { uid: EFFECT.HEIGHTENED_SENSES },
    { uid: EFFECT.COMPETITION },
    { uid: EFFECT.BANE_OF_HELLS_KITCHEN },
    { uid: EFFECT.DEFENDERS_DESTROYER },
    { uid: EFFECT.SPLIT_PERSONALITY },
    { uid: EFFECT.ELECTRIC_SUPERCHARGE },
    { uid: EFFECT.SEETHING_HATRED },
    { uid: EFFECT.PARTICLE_PHYSICS },
    { uid: EFFECT.ENGINEERING },
    { uid: EFFECT.BIOCHEMISTRY },
    { uid: EFFECT.AVENGERS_TRYOUT },
    { uid: EFFECT.KNOWLEDGE_SHARE },
    { uid: EFFECT.CONTEST_NOOBS },
    { uid: EFFECT.MASTERS_OF_THE_SWORD },
    { uid: EFFECT.SOUL_SEEKER },
    { uid: EFFECT.WARRIOR_QUEENS },
    { uid: EFFECT.BELIEVER },
    { uid: EFFECT.CROSS_TRAINING },
    { uid: EFFECT.LOYAL_MINISTER },
    { uid: EFFECT.TEAM_BUILDING_EXERCISE },
    { uid: EFFECT.LULLABY },
    { uid: EFFECT.OFF_LIMITS },
    { uid: EFFECT.PUNY_GOD },
    { uid: EFFECT.OVERCOMING_FEAR },
    { uid: EFFECT.LIKE_OLD_DAYS },
    { uid: EFFECT.NOT_AFRAID_OF_DEATH },
    { uid: EFFECT.FRIEND_FROM_WORK },
    { uid: EFFECT.ADVANCED_IDEA_MECHANICS },
    { uid: EFFECT.CHAIR_LARCENY },
    { uid: EFFECT.IMMORTAL_SOULS },
    { uid: EFFECT.QUEEN_OF_HEL },
    { uid: EFFECT.HELL_LORDS },
    { uid: EFFECT.OTHER_HALF },
    { uid: EFFECT.CUBICLE_MATES },
    { uid: EFFECT.TERMINATION_CONTRACT },
    { uid: EFFECT.PROFESSORS_IN_CRIME },
    { uid: EFFECT.MOSTLY_AVERAGE_JOES },
    { uid: EFFECT.THUNDER },
    { uid: EFFECT.TEAM_DEADPOOL_AWESOME_FORCE },
    { uid: EFFECT.BROKEN_MINDS },
    { uid: EFFECT.ANNOYANCES_ASSEMBLE },
    { uid: EFFECT.SIX_PACK },
    { uid: EFFECT.XFORCE },
    { uid: EFFECT.WEAPON_X_STRIKE_TEAM },
    { uid: EFFECT.MERCS_FOR_MONEY },
    { uid: EFFECT.CODE_RED_REVELATIONS },
    { uid: EFFECT.BETTER_LUCK_NEXT_TIME },
    { uid: EFFECT.COMPLICATED },
    { uid: EFFECT.ESOTERIC_INSIGHT },
    { uid: EFFECT.COVERT_INSIGHT },
    { uid: EFFECT.FAMILIAR_INSIGHT },
    { uid: EFFECT.AI_UPGRADE },
    { uid: EFFECT.WAKANDAN_INSIGHT },
    { uid: EFFECT.ENHANCED_SOLDIERS },
    { uid: EFFECT.WAKANDA_LEADERSHIP },
    { uid: EFFECT.FEARLESS },
    { uid: EFFECT.MUTANT_PURSUIT },
    { uid: EFFECT.SKILL_TRAINING },
    { uid: EFFECT.SCIENCE_RESEARCH },
    { uid: EFFECT.MYSTIC_OBSERVATION },
    { uid: EFFECT.TECH_ADVANCEMENT },
    { uid: EFFECT.CHRONAL_ANCHOR },
    { uid: EFFECT.ENERGY_CONDUIT },
    { uid: EFFECT.DEMONS },
    { uid: EFFECT.PACT_WITH_A_DEMON },
    { uid: EFFECT.INHUMAN_ROYAL_FAMILY },
    { uid: EFFECT.INSPIRATION },
    { uid: EFFECT.GET_IN_THE_POOL },
    { uid: EFFECT.SPIRITUAL_STRENGTH },
    { uid: EFFECT.PLAYING_WITH_FIRE },
    { uid: EFFECT.TECH_BREAKTHROUGH },
    { uid: EFFECT.MUTANT_EVOLUTION },
    { uid: EFFECT.SKILL_TRAINING_CAIW },
    { uid: EFFECT.SCIENCE_EXPERIMENT },
    { uid: EFFECT.MYSTIC_CRAFT },
    { uid: EFFECT.COSMIC_POWER },
    { uid: EFFECT.ADVANCED_TECH },
    { uid: EFFECT.DEADLY_STING },
    { uid: EFFECT.HARD_TO_HIT },
    { uid: EFFECT.UNTAMED_FORCE },
    { uid: EFFECT.DECIMATION },
    { uid: EFFECT.NO_MERCY },
    { uid: EFFECT.FORMIDABLE_FOE },
    { uid: EFFECT.THE_UNTOUCHABLES },
    { uid: EFFECT.MICROSCOPIC_OBSERVATION },
    { uid: EFFECT.UNMERCIFUL_PUNISHMENT },
    { uid: EFFECT.ASGARDIAN_HUNT },
    { uid: EFFECT.SPECIAL_ASSIST },
    { uid: EFFECT.HUNT_THE_UNCANNY },
    { uid: EFFECT.CHALLENGE_DEFENSES },
    { uid: EFFECT.GRIPPED_BY_FEAR },
    { uid: EFFECT.ENGULFED_BY_THE_VOID },
    { uid: EFFECT.ENCHANTED_BLADES },
    { uid: EFFECT.LOST_DAUGHTERS_OF_ASGARD },
    { uid: EFFECT.WARRIORS_OF_ASGARD },
    { uid: EFFECT.PIT_FIGHTERS },
    { uid: EFFECT.GRANDMASTERS_CHAMPIONS },
    { uid: EFFECT.ELEMENTAL_HIDE },
    { uid: EFFECT.DARK_ILLUMINATI },
    { uid: EFFECT.ETERNAL_ADVERSARIES },
    { uid: EFFECT.HAIL_HYDRA },
    { uid: EFFECT.DARK_EMPOWERMENT },
    { uid: EFFECT.METAL_MAYHEM },
    { uid: EFFECT.XASSASSINS },
    { uid: EFFECT.SEEING_RED },
    { uid: EFFECT.DEADLY_PRESENCE },
    { uid: EFFECT.MEMORIES_OF_GENOSHA },
    { uid: EFFECT.IMPENETRABLE_HIDE },
    { uid: EFFECT.ITS_COMPLICATED_2 },
    { uid: EFFECT.PHOENIX_FORCE },
    { uid: EFFECT.COMBO_FIGHTER },
    { uid: EFFECT.PERSISTENT_FORCE },
    { uid: EFFECT.TOUGH_BRAWLERS },
    { uid: EFFECT.DAVID_AND_GOLIATH },
    { uid: EFFECT.COMBO_BREAKERS },
    { uid: EFFECT.WARRIORS_OF_THE_STARS },
    { uid: EFFECT.FRIENDS },
    { uid: EFFECT.SCHOOL_OF_HARD_ROCKS },
    { uid: EFFECT.WORTHY_OPPONENT },
    { uid: EFFECT.UNENDING_AMBITION },
    { uid: EFFECT.MADCAP_EXPERIMENTALISTS },
    { uid: EFFECT.TWISTED_ARCANISTS },
    { uid: EFFECT.LEGION_ACCURSED },
    { uid: EFFECT.GENETIC_RECODE_BARRIER },
    { uid: EFFECT.GENETIC_RECODE_SURVIVAL },
    { uid: EFFECT.GENETIC_RECODE_HIVE_MIND },
    { uid: EFFECT.GENETIC_RECODE_REGENESIS },
    { uid: EFFECT.GENETIC_RECODE_EVOLUTION },
    { uid: EFFECT.GENETIC_RECODE_AGGRESSION },
    { uid: EFFECT.GENETIC_RECODE_PROBABILITY },
    { uid: EFFECT.GENETIC_RECODE_BLOODLETTING },
    { uid: EFFECT.MYSTIC_MASTERS },
    { uid: EFFECT.ANCIENT_HUNGER },
    { uid: EFFECT.SUPREME_SYMBIOSIS },
    { uid: EFFECT.MIDNIGHT_PURSUIT },
    { uid: EFFECT.JUSTICE_ON_WHEELS },
    { uid: EFFECT.CONTEST_TEAMMATES },
    { uid: EFFECT.TACTICAL_TRAINING },
    { uid: EFFECT.NIGHT_HAWKS },
    { uid: EFFECT.DARK_JUSTICE },
    { uid: EFFECT.BIRDS_OF_PREY },
    { uid: EFFECT.RUNS_IN_THE_FAMILY },
    { uid: EFFECT.OLD_TEAMMATES },
    { uid: EFFECT.UNCANNY_AVENGERS },
    { uid: EFFECT.GENETIC_MASTERPIECE },
    { uid: EFFECT.MUTANT_DOMINION },
    { uid: EFFECT.BLOOD_LINES },
    { uid: EFFECT.MASTERMINDS_TWO },
    { uid: EFFECT.STOLEN_MEMORIES },
    { uid: EFFECT.PARTNERS_IN_SHIELD },
    { uid: EFFECT.MARVELOUS },
    { uid: EFFECT.FAN_CLUB },
    { uid: EFFECT.RESTORATION_KIT },
    { uid: EFFECT.STRATEGIC_SABOTAGE },
    { uid: EFFECT.INCREASED_FIREPOWER },
    { uid: EFFECT.CONTINGENCY_PLAN },
    { uid: EFFECT.EXTREME_CONDITIONS_KIT },
    { uid: EFFECT.POWER_KIT },
    { uid: EFFECT.GWENOM_RISING },
    { uid: EFFECT.AGENTS_OF_SMASH },
    { uid: EFFECT.HUNTRESS_OF_THE_CONTEST },
    { uid: EFFECT.SIBLING_RIVALRY },
    { uid: EFFECT.CYBERNETICS_UPGRADE_ASSAULT },
    { uid: EFFECT.CYBERNETICS_UPGRADE_TACTICS },
    { uid: EFFECT.DOUBLE_NEGATIVE },
    { uid: EFFECT.CHALLENGER },
    { uid: EFFECT.RAIN_OF_FIRE },
    { uid: EFFECT.TURN_UP_THE_HEAT },
    { uid: EFFECT.A_SONG_OF_FIRE_AND_ICE },
    { uid: EFFECT.FAMILIAR_FACES },
    { uid: EFFECT.LAST_HOPE },
    { uid: EFFECT.UNLIKELY_COMBINATION },
    { uid: EFFECT.LIVE_AND_DIE_BY_THE_SWORD },
    { uid: EFFECT.MASTERLESS },
    { uid: EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER },
    { uid: EFFECT.CULL_OF_THE_MAW },
    { uid: EFFECT.INVASIVE_FORCE },
    { uid: EFFECT.DISPLAY_OF_STRENGTH },
    { uid: EFFECT.HEROES_NEVER_LEARN },
    { uid: EFFECT.TIDE_TO_GO },
    { uid: EFFECT.KINGS_OF_THE_WORLD },
    { uid: EFFECT.BEACH_BODS },
    { uid: EFFECT.FORCE_BLOCK },
    { uid: EFFECT.TILL_DEATH },
    { uid: EFFECT.UNPHASED },
    { uid: EFFECT.ONE_WAY_OR_ANOTHER },
    { uid: EFFECT.STARK_INTERNSHIP },
    { uid: EFFECT.SPIDERMEN_IN_BLACK },
    { uid: EFFECT.BAD_FOR_BUSINESS },
    { uid: EFFECT.CULTURE_SHOCK },
    { uid: EFFECT.MINE_CAN_HOVER },
    { uid: EFFECT.ENCROACHING_INSANITY },
    { uid: EFFECT.ENHANCED_ILLUSIONIST },
    { uid: EFFECT.MENTAL_IMMUNITY },
    { uid: EFFECT.NEW_MUTANTS },
    { uid: EFFECT.AIM_TECHNOLOGY },
    { uid: EFFECT.LEADING_AVENGERS },
    { uid: EFFECT.SELFFRIENDS },
    { uid: EFFECT.ROBOT_UPRISING },
    { uid: EFFECT.GOING_VIRAL },
    { uid: EFFECT.FIRST_OF_HIS_NAME },
    { uid: EFFECT.DRY_ICE },
    { uid: EFFECT.SENIORS_DISCOUNT },
    { uid: EFFECT.JUDGEMENT_DAY },
    { uid: EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY },
    { uid: EFFECT.FIRE_AND_FORGET },
    { uid: EFFECT.SPIDERS_BITE },
    { uid: EFFECT.FEARSOME_FOUR },
    { uid: EFFECT.BANE_OF_EVIL },
    { uid: EFFECT.THINGS },
    { uid: EFFECT.MISUNDERSTOOD_MONSTERS },
    { uid: EFFECT.AI_UPRISING },
    { uid: EFFECT.OUR_SHARED_CURSE },
    { uid: EFFECT.HUNTING_PARTY },
    { uid: EFFECT.BEAUTY_AND_THE_BEAST },
    { uid: EFFECT.FANTASTIC_RAGE },
    { uid: EFFECT.ENHANCED_FORCEFIELD },
    { uid: EFFECT.GENIUS_INGENUITY },
    { uid: EFFECT.SORCERY_REVERSAL },
    { uid: EFFECT.MYSTIC_TYRANTS },
    { uid: EFFECT.COSMIC_OVERLOAD },
    { uid: EFFECT.HERBIE },
    { uid: EFFECT.FANTASTIC_FOUR },
    { uid: EFFECT.DO_US_PART },
    { uid: EFFECT.COLLEGE_RIVALS },
    { uid: EFFECT.SK_ASTRONOMY },
    { uid: EFFECT.SK_ROBOTICS },
    { uid: EFFECT.SK_GENETICS },
    { uid: EFFECT.HERALDS_OF_GALACTUS },
    { uid: EFFECT.SECRET_DEFENDERS },
    { uid: EFFECT.MINE_TRAVELS_THROUGH_SPACE },
    { uid: EFFECT.NEW_WARRIOR_BLOOD },
    { uid: EFFECT.TOTAL_ANNIHILATION },
    { uid: EFFECT.MAXIMUM_OUTPUT },
    { uid: EFFECT.PHALANX_FEUD },
    { uid: EFFECT.FULL_SPEED_AHEAD },
    { uid: EFFECT.SUPERNANNY },
    { uid: EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS },
    { uid: EFFECT.HARDWIRED_FOR_HEARTBREAK },
    { uid: EFFECT.BEAT_UP_THE_UNIVERSE },
    { uid: EFFECT.MOJOVERSE },
    { uid: EFFECT.SMILE_FOR_THE_CAMERAS },
    { uid: EFFECT.WITHOUT_A_LEG_TO_STAND_ON },
    { uid: EFFECT.CROWD_PLEASERS },
    { uid: EFFECT.CIVIL_WAR_STORIES },
    { uid: EFFECT.LOVE_TRIANGLES },
    { uid: EFFECT.PROBABLY_OP },
    { uid: EFFECT.GOOD_VIBRATIONS },
    { uid: EFFECT.MONSTER_MASH },
    { uid: EFFECT.FANTASTIC_FIENDS },
    { uid: EFFECT.DEATH_AND_RESURRECTION },
    { uid: EFFECT.ELDERS_GAME },
    { uid: EFFECT.PRISONER },
    { uid: EFFECT.A_GANG_OF },
    { uid: EFFECT.LAB_PARTNERS },
    { uid: EFFECT.TROPHY_CASE },
    { uid: EFFECT.CHAMPIONS_OF_BATTLEWORLD },
    { uid: EFFECT.DOCTORS_STRANGE },
    { uid: EFFECT.MYSTIC_ARTS },
    { uid: EFFECT.BLUETIFUL_PEOPLE },
    { uid: EFFECT.GAMMA_HORDE },
    { uid: EFFECT.HOUSE_OF_IRON },
    { uid: EFFECT.SETUP_AND_SPIKE },
    { uid: EFFECT.UNDER_THE_WEATHER },
    { uid: EFFECT.KINGDOM_OF_WAKANDA },
    { uid: EFFECT.SPIDERGUILD },
    { uid: EFFECT.FAMILY_REUNION },
    { uid: EFFECT.EASTERN_BLOCKERS },
    { uid: EFFECT.LIVING_STEEL_CURTAIN },
    { uid: EFFECT.MAGNIFICENT_MANES },
    { uid: EFFECT.ENHANCED_WITH_CARBONADIUM },
    { uid: EFFECT.REMEMBER_ME },
    { uid: EFFECT.REMEMBERING_BUDAPEST },
    { uid: EFFECT.COVERT_EXPERTISE },
    { uid: EFFECT.WEST_COAST_AVENGERS },
    { uid: EFFECT.FELINE_POSSESSION },
    { uid: EFFECT.ENTREE },
    { uid: EFFECT.BIG_GAME_HUNTERS },
    { uid: EFFECT.NOT_THE_FACE },
    { uid: EFFECT.SPIDER_MONKEY },
    { uid: EFFECT.FURRY_FRENEMIES },
    { uid: EFFECT.NO_EVIL },
    { uid: EFFECT.ON_GUARD_FOR_THEE },
    { uid: EFFECT.ALPHA_FLIGHT },
    { uid: EFFECT.EXCAVATORS },
    { uid: EFFECT.JUST_HAIR_AND_THINGS },
    { uid: EFFECT.GAMMA_RAY_RAY },
    { uid: EFFECT.FURRY_BUDS },
    { uid: EFFECT.GIANT_CHALLENGERS },
    { uid: EFFECT.COMMON_HISTORY },
    { uid: EFFECT.NOVA_CORPS_VETERANS },
    { uid: EFFECT.THE_HIGH_GROUND },
    { uid: EFFECT.THE_FIRST_ONE },
    { uid: EFFECT.BRINGER_OF_DEATH_I },
    { uid: EFFECT.BRINGER_OF_DEATH_II },
    { uid: EFFECT.BRINGER_OF_DEATH_III },
    { uid: EFFECT.BRINGER_OF_DEATH_IV },
    { uid: EFFECT.GUARDIAN_OF_THE_PYRAMID },
    { uid: EFFECT.IMPENDING_STORM },
    { uid: EFFECT.YOUR_FATE_IS_MINE },
    { uid: EFFECT.CHAOTIC_ENERGY },
    { uid: EFFECT.CROSSOVER },
    { uid: EFFECT.DEATHWISH },
    { uid: EFFECT.GOODFELLA },
    { uid: EFFECT.MERC_WITH_A_MOUTH },
    { uid: EFFECT.STUCK_IN_LIMBO },
    { uid: EFFECT.DRUG_I },
    { uid: EFFECT.DRUG_L },
    { uid: EFFECT.DRUG_M },
    { uid: EFFECT.GATEWAY },
    { uid: EFFECT.HABITAT },
    { uid: EFFECT.FIRST_CRUSH },
    { uid: EFFECT.FULL_METAL },
    { uid: EFFECT.NOT_SO_HIDDEN_DRAGON },
    { uid: EFFECT.STUDENT_LOANS },
    { uid: EFFECT.MY_BROTHERHOOD },
    { uid: EFFECT.MY_CONTEST_NOW },
    { uid: EFFECT.MY_HELLFIRE_CLUB },
    { uid: EFFECT.MY_METALLIC_ANTIPATHY },
    { uid: EFFECT.METALLIC_AFFINITY },
    { uid: EFFECT.REDEMPTION },
    { uid: EFFECT.RISE_AGAINST_THE_CONTEST },
    { uid: EFFECT.FAMILY_FEUD },
    { uid: EFFECT.HATRED },
    { uid: EFFECT.OSBORN_TO_BE_WILD },
    { uid: EFFECT.SELF_CENTERED },
    { uid: EFFECT.SYMBIOTE_CONSCIOUSNESS },
    { uid: EFFECT.COSMIC_BANE_OF_EVIL },
    { uid: EFFECT.COSMIC_JUSTICE_ON_WHEELS },
    { uid: EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY },
    { uid: EFFECT.SPIRITS_OF_VENGEANCE },
    { uid: EFFECT.FASTBALL_SPECIAL },
    { uid: EFFECT.FEEL_CYTORAKS_EMBRACE },
    { uid: EFFECT.DONT_MENTION_PUNY_BANNER },
    { uid: EFFECT.TECHNOLOGICAL_COMPETITION },
    { uid: EFFECT.ENGINEERING_EXPERTS },
    { uid: EFFECT.IT_AINT_EASY },
    { uid: EFFECT.SINGULARITY },
    { uid: EFFECT.ENHANCED_ADAMANTIUM },
    { uid: EFFECT.NO_NOT_YOU },
    { uid: EFFECT.THE_BRAVE_AND_THE_BOULDER },
    { uid: EFFECT.PASSIVE_AGGRESSIVE },
    { uid: EFFECT.ARACHNID_HUNTERS },
    { uid: EFFECT.ALPHA_FLIGHT_SPACE_STATION },
    { uid: EFFECT.GAMMA_MUTATES },
    { uid: EFFECT.EXTREME_MEASURES },
    { uid: EFFECT.HELL_AND_BACK },
    { uid: EFFECT.FAIREST_OF_THEM_ALL },
    { uid: EFFECT.ABOMINABLE_COMRADE },
    { uid: EFFECT.IMMORTAL_RULERS },
    { uid: EFFECT.IMMORTAL_KINGS },
    { uid: EFFECT.TWO_DAYS_THIRTY_YEARS },
    { uid: EFFECT.SATURDAY_MORNING_CARTOONS },
    { uid: EFFECT.SWINESTER_SIX_MOST_WANTED },
    { uid: EFFECT.FOURTH_WALL_CRAWLER },
    { uid: EFFECT.FISK_DOWNFALL },
    { uid: EFFECT.SECRET_OF_THE_HAND },
    { uid: EFFECT.RULE_OF_LAW },
    { uid: EFFECT.STRENGTH_OF_MARTYRS },
    { uid: EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE },
    { uid: EFFECT.DEAL_WITH_IT },
    { uid: EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE },
    { uid: EFFECT.PETITE },
    { uid: EFFECT.THE_LUCKY_ONE },
    { uid: EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN },
    { uid: EFFECT.BIG_BAD_DAD },
    { uid: EFFECT.BULL_TARGETS },
    { uid: EFFECT.CLONED_AT_BIRTH },
    { uid: EFFECT.MISS_ME },
    { uid: EFFECT.HOSTILE_TAKEOVER },
    { uid: EFFECT.WEDDING_CRASHER },
    { uid: EFFECT.DINKY_SHRINKS },
    { uid: EFFECT.MALICE },
    { uid: EFFECT.PURE_HATRED },
    { uid: EFFECT.THERE_GOES_THE_MULTIVERSE },
    { uid: EFFECT.POWER_OF_MONEY },
    { uid: EFFECT.REVOLUTIONS_NEED_ARMS },
    { uid: EFFECT.AMBER_PRISON },
    { uid: EFFECT.BANISHED },
    { uid: EFFECT.ENERGY_ABSORPTION },
    { uid: EFFECT.FUELED_WITH_RAGE },
    { uid: EFFECT.RAGE_ON },
    { uid: EFFECT.BATTLE_OF_REALMS },
    { uid: EFFECT.OATHSWORN },
    { uid: EFFECT.ODINSONS_AND_ODINSDOTTIRS },
    { uid: EFFECT.WARMONGER },
    { uid: EFFECT.HYDRA_RECRUITERS },
    { uid: EFFECT.MERCENARY_COMPETITION },
    { uid: EFFECT.CONTEMPTUOUS_HATRED },
    { uid: EFFECT.WE_AINT_NO_PUNCHLINE },
    { uid: EFFECT.NEW_YORK_BRAWLERS },
    { uid: EFFECT.NOT_SO_UNCANNY },
    { uid: EFFECT.IRON_MEN },
    { uid: EFFECT.ASGARDIAN_REPUBLIC },
    { uid: EFFECT.PATRIOT_GARRISON },
    { uid: EFFECT.PET_PALS },
    { uid: EFFECT.HUNTRESSES },
    { uid: EFFECT.PYRAMID_X },
    { uid: EFFECT.TEMPLE_OF_VISHANTI },
    { uid: EFFECT.TRIBAL_WARFARE },
    { uid: EFFECT.EYES_OF_THE_DRAGON },
    { uid: EFFECT.MASTER_MARTIAL_ARTISTS },
    { uid: EFFECT.SHADOWLAND },
    { uid: EFFECT.THE_WAY_OF_THE_SPIDER },
    { uid: EFFECT.A_BEING_DARKER_THAN_I },
    { uid: EFFECT.FROM_LIGHT_TO_DARK },
    { uid: EFFECT.HEALING_TOUCH },
    { uid: EFFECT.TIME_WE_CHANGED_TOO },
    { uid: EFFECT.BATTLEREALMS_CHANGING },
    { uid: EFFECT.KINGS },
    { uid: EFFECT.ROYALS },
    { uid: EFFECT.WARRIORS },
    { uid: EFFECT.DIMENSIONAL_BUDDIES },
    { uid: EFFECT.MANY_AS_ONE },
    { uid: EFFECT.POOR_UNFORTUNATE_SOUL },
    { uid: EFFECT.QUEENS_OF_SOULS },
    { uid: EFFECT.UNCHAINED },
    { uid: EFFECT.WHAT_IF },
    { uid: EFFECT.COSMIC_CONTROL },
    { uid: EFFECT.CUBE_WIELDERS },
    { uid: EFFECT.IDENTITY_DISORDER },
    { uid: EFFECT.SHIELD_BUDDIES },
    { uid: EFFECT.SPACE_SURFERS },
    { uid: EFFECT.FORTIFY_ENHANCEMENT },
    { uid: EFFECT.SKIRMISH_ENHANCEMENT },
    { uid: EFFECT.SUPPORT_ENHANCEMENT },
    { uid: EFFECT.MY_BEAUTIFUL_METEOR },
    { uid: EFFECT.MY_WORLD_OF_METAL },
    { uid: EFFECT.DECIMATION_SW },
    { uid: EFFECT.CHAOS_RISING },
    { uid: EFFECT.TILL_INFINITY_DO_US_PART },
    { uid: EFFECT.DEMONIC_PACT },
    { uid: EFFECT.SUPER_STARS },
    { uid: EFFECT.OUT_OF_THIS_WORLD },
    { uid: EFFECT.STAY_POSITIVE },
    { uid: EFFECT.KO_QUEENS },
    { uid: EFFECT.NEXT_ROUND_ON_ME },
    { uid: EFFECT.MASTERFUL_COMBAT },
    { uid: EFFECT.ARM_WRESTLING_CLUB },
    { uid: EFFECT.PAWN_SET_FREE },
    { uid: EFFECT.INCREDIBLE_SUBSTITUTE },
    { uid: EFFECT.I_REQUIRE_THY_SHIELD },
    { uid: EFFECT.START_WITH_FRESH_DEADPOOL },
    { uid: EFFECT.ACCURATELY_MEASURE_INGREDIENTS },
    { uid: EFFECT.BLEND_IN_SYMBIOTE },
    { uid: EFFECT.ADD_PLAIN_WHITE_FLOUR },
    { uid: EFFECT.FRY_IN_SKILLET },
    { uid: EFFECT.ADJUST_COOKING_TIMER },
    { uid: EFFECT.ALLOW_TO_COOL },
    { uid: EFFECT.MUNCH_STUNNING_FOOD },
    { uid: EFFECT.NOT_THE_HERO },
    { uid: EFFECT.BUT_THE_BEST_VILLAIN },
    { uid: EFFECT.CRIME_BOSSES },
    { uid: EFFECT.CONTEMPTUOUS_MALICE },
    { uid: EFFECT.GIANT_MONSTROSITIES },
    { uid: EFFECT.ANGEL_ATTACK },
    { uid: EFFECT.FIELD_TRIP },
    { uid: EFFECT.SPIDERGEDDON },
    { uid: EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES },
    { uid: EFFECT.SUIT_UP },
    { uid: EFFECT.TECHNICIAN },
    { uid: EFFECT.AI_ENTHUSIASTS },
    { uid: EFFECT.COWORKERS },
    { uid: EFFECT.SPIDERVERSE_VETERANS },
    { uid: EFFECT.SYMBIOTE_PROBLEMS },
    { uid: EFFECT.WE_ARE_MANY },
    { uid: EFFECT.ADVANCED_INTELLIGENCE },
    // { uid: EFFECT.NEW_WAVE },
    { uid: EFFECT.RESISTANCE_IS_FUTILE },
    { uid: EFFECT.TERMINATED },
    { uid: EFFECT.FIRE_AND_DRAGONS },
    { uid: EFFECT.JUST_A_PHASE },
    { uid: EFFECT.SHADOWY_HISTORY },
    { uid: EFFECT.THROUGH_THICK_AND_THIN },
    { uid: EFFECT.VICIOUS_KITTY },
    { uid: EFFECT.WORTH_A_SHOT },
    { uid: EFFECT.SPIDERSENSES_TINGLING },
    { uid: EFFECT.SPIDERVERSE_MENTORS },
    { uid: EFFECT.CYBERNETICS_UPGRADE_BLITZ },
].map(({ uid }) => new Effect({
    uid,
    base: EFFECT_STARS_AMOUNT[ uid ][ 0 ],
}));

const effectIcons = {
    [ EFFECT.ATTACK ]: 'effect-attack',
    [ EFFECT.IDOL ]: 'effect-idol',
    [ EFFECT.INSEPARABLE ]: 'effect-inseparable',
    [ EFFECT.MUTANT_AGENDA ]: 'effect-mutant-agenda',
    [ EFFECT.COSMIC_SUPREMACY ]: 'effect-cosmic-supremacy',
    [ EFFECT.CRITICAL_RATE ]: 'effect-critical-rate',
    [ EFFECT.CRITICAL_DAMAGE ]: 'effect-critical-damage',
    [ EFFECT.BLEED ]: 'effect-bleed',
    [ EFFECT.COMBO ]: 'effect-combo',
    [ EFFECT.LEGAL_DEFENSE ]: 'effect-stun',
    [ EFFECT.STUN_SPECIAL ]: 'effect-stun-special',
    [ EFFECT.POWER_GAIN ]: 'effect-power',
    [ EFFECT.POWER_STEAL ]: 'effect-power-lock',
    [ EFFECT.ITS_COMPLICATED ]: 'effect-power',
    [ EFFECT.PERFECT_BLOCK ]: 'effect-perfect-block',
    [ EFFECT.ARMOR ]: 'effect-armor',
    [ EFFECT.HEALTH ]: 'effect-health',
    [ EFFECT.HEALTH_STEAL ]: 'effect-health-steal',
    [ EFFECT.HEROES_FOR_HIRE ]: 'effect-heroes-for-hire',
    [ EFFECT.THUNDERBOLTS ]: 'effect-thunderbolts',
    [ EFFECT.MASTERMINDS ]: 'effect-masterminds',
    [ EFFECT.SHIELD_AGENTS ]: 'effect-shield',
    [ EFFECT.SHIELD_CLEARANCE ]: 'effect-shield',
    [ EFFECT.SHARED_GENETIC_MEMORY ]: 'effect-shared-genetic-memory',
    [ EFFECT.DEMON_HUNTER ]: 'type-mystic',
    [ EFFECT.SPIRIT_OF_JUSTICE ]: 'effect-spirit-of-justice',
    [ EFFECT.HEIGHTENED_SENSES ]: 'effect-heightened-senses',
    [ EFFECT.COMPETITION ]: 'effect-competition',
    [ EFFECT.BANE_OF_HELLS_KITCHEN ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.DEFENDERS_DESTROYER ]: 'effect-armor-break',
    [ EFFECT.SPLIT_PERSONALITY ]: 'effect-inseparable',
    [ EFFECT.ELECTRIC_SUPERCHARGE ]: 'effect-electric-supercharge',
    [ EFFECT.SEETHING_HATRED ]: 'effect-seething-hatred',
    [ EFFECT.PARTICLE_PHYSICS ]: 'effect-particle-physics',
    [ EFFECT.ENGINEERING ]: 'type-tech',
    [ EFFECT.BIOCHEMISTRY ]: 'effect-biochemistry',
    [ EFFECT.AVENGERS_TRYOUT ]: 'effect-avengers-tryout',
    [ EFFECT.KNOWLEDGE_SHARE ]: 'effect-masterminds',
    [ EFFECT.CONTEST_NOOBS ]: 'effect-inseparable',
    [ EFFECT.MASTERS_OF_THE_SWORD ]: 'effect-masters-of-the-sword',
    [ EFFECT.SOUL_SEEKER ]: 'effect-soul-seeker',
    [ EFFECT.WARRIOR_QUEENS ]: 'effect-warrior-queens',
    [ EFFECT.BELIEVER ]: 'effect-believer',
    [ EFFECT.CROSS_TRAINING ]: 'effect-degeneration',
    [ EFFECT.LOYAL_MINISTER ]: 'effect-combo',
    [ EFFECT.TEAM_BUILDING_EXERCISE ]: 'effect-unstoppable',
    [ EFFECT.LULLABY ]: 'effect-lullaby',
    [ EFFECT.OFF_LIMITS ]: 'effect-lullaby',
    [ EFFECT.PUNY_GOD ]: 'effect-combo',
    [ EFFECT.OVERCOMING_FEAR ]: 'effect-overcoming-fear',
    [ EFFECT.LIKE_OLD_DAYS ]: 'effect-like-old-days',
    [ EFFECT.NOT_AFRAID_OF_DEATH ]: 'effect-regeneration',
    [ EFFECT.FRIEND_FROM_WORK ]: 'effect-friend-from-work',
    [ EFFECT.ADVANCED_IDEA_MECHANICS ]: 'effect-advanced-idea-mechanics',
    [ EFFECT.CHAIR_LARCENY ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.IMMORTAL_SOULS ]: 'effect-nullify',
    [ EFFECT.QUEEN_OF_HEL ]: 'effect-regeneration',
    [ EFFECT.HELL_LORDS ]: 'effect-hell-lords',
    [ EFFECT.CUBICLE_MATES ]: 'effect-biochemistry',
    [ EFFECT.OTHER_HALF ]: 'effect-degeneration',
    [ EFFECT.TERMINATION_CONTRACT ]: 'effect-overcoming-fear',
    [ EFFECT.PROFESSORS_IN_CRIME ]: 'effect-hell-lords',
    [ EFFECT.MOSTLY_AVERAGE_JOES ]: 'effect-mostly-average-joes',
    [ EFFECT.THUNDER ]: 'effect-shock',
    [ EFFECT.TEAM_DEADPOOL_AWESOME_FORCE ]: 'effect-immunity-bleed',
    [ EFFECT.ANNOYANCES_ASSEMBLE ]: 'effect-annoyances-assemble',
    [ EFFECT.BROKEN_MINDS ]: 'effect-broken-minds',
    [ EFFECT.SIX_PACK ]: 'effect-attack',
    [ EFFECT.XFORCE ]: 'effect-perfect-block',
    [ EFFECT.WEAPON_X_STRIKE_TEAM ]: 'effect-weapon-x',
    [ EFFECT.MERCS_FOR_MONEY ]: 'effect-mercs-for-money',
    [ EFFECT.CODE_RED_REVELATIONS ]: 'effect-mercs-for-money',
    [ EFFECT.BETTER_LUCK_NEXT_TIME ]: 'effect-advanced-idea-mechanics',
    [ EFFECT.COMPLICATED ]: 'effect-power',
    [ EFFECT.ESOTERIC_INSIGHT ]: 'effect-power-lock',
    [ EFFECT.COVERT_INSIGHT ]: 'effect-evade',
    [ EFFECT.FAMILIAR_INSIGHT ]: 'effect-perfect-block',
    [ EFFECT.WAKANDAN_INSIGHT ]: 'effect-wakandan-insight',
    [ EFFECT.AI_UPGRADE ]: 'type-tech',
    [ EFFECT.ENHANCED_SOLDIERS ]: 'effect-friend-from-work',
    [ EFFECT.WAKANDA_LEADERSHIP ]: 'effect-perfect-block',
    [ EFFECT.FEARLESS ]: 'effect-regeneration',
    [ EFFECT.MUTANT_PURSUIT ]: 'effect-mutant-pursuit',
    [ EFFECT.SKILL_TRAINING ]: 'effect-skill-training',
    [ EFFECT.SCIENCE_RESEARCH ]: 'effect-science-research',
    [ EFFECT.MYSTIC_OBSERVATION ]: 'effect-mystic-observation',
    [ EFFECT.TECH_ADVANCEMENT ]: 'effect-tech-advancement',
    [ EFFECT.CHRONAL_ANCHOR ]: 'effect-chronal-anchor',
    [ EFFECT.ENERGY_CONDUIT ]: 'effect-resist-energy',
    [ EFFECT.DEMONS ]: 'effect-demons',
    [ EFFECT.PACT_WITH_A_DEMON ]: 'effect-mercs-for-money',
    [ EFFECT.INHUMAN_ROYAL_FAMILY ]: 'effect-armor-break',
    [ EFFECT.INSPIRATION ]: 'effect-critical-rate',
    [ EFFECT.GET_IN_THE_POOL ]: 'effect-mercs-for-money',
    [ EFFECT.SPIRITUAL_STRENGTH ]: 'effect-evade',
    [ EFFECT.PLAYING_WITH_FIRE ]: 'effect-mercs-for-money',
    [ EFFECT.TECH_BREAKTHROUGH ]: 'type-tech',
    [ EFFECT.MUTANT_EVOLUTION ]: 'type-mutant',
    [ EFFECT.SKILL_TRAINING_CAIW ]: 'type-skill',
    [ EFFECT.SCIENCE_EXPERIMENT ]: 'type-science',
    [ EFFECT.MYSTIC_CRAFT ]: 'type-mystic',
    [ EFFECT.COSMIC_POWER ]: 'type-cosmic',
    [ EFFECT.ADVANCED_TECH ]: 'effect-masterminds',
    [ EFFECT.DEADLY_STING ]: 'effect-deadly-string',
    [ EFFECT.HARD_TO_HIT ]: 'effect-evade',
    [ EFFECT.UNTAMED_FORCE ]: 'effect-regeneration',
    [ EFFECT.DECIMATION ]: 'effect-friend-from-work',
    [ EFFECT.NO_MERCY ]: 'effect-hell-lords',
    [ EFFECT.FORMIDABLE_FOE ]: 'effect-attack',
    [ EFFECT.MICROSCOPIC_OBSERVATION ]: 'effect-mostly-average-joes',
    [ EFFECT.THE_UNTOUCHABLES ]: 'effect-untouchables',
    [ EFFECT.UNMERCIFUL_PUNISHMENT ]: 'effect-friend-from-work',
    [ EFFECT.ASGARDIAN_HUNT ]: 'effect-critical-rate',
    [ EFFECT.SPECIAL_ASSIST ]: 'effect-idol',
    [ EFFECT.HUNT_THE_UNCANNY ]: 'effect-critical-damage',
    [ EFFECT.CHALLENGE_DEFENSES ]: 'effect-directdamage',
    [ EFFECT.GRIPPED_BY_FEAR ]: 'effect-friend-from-work',
    [ EFFECT.ENGULFED_BY_THE_VOID ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.ENCHANTED_BLADES ]: 'effect-critical-rate',
    [ EFFECT.LOST_DAUGHTERS_OF_ASGARD ]: 'effect-attack',
    [ EFFECT.WARRIORS_OF_ASGARD ]: 'effect-regeneration',
    [ EFFECT.PIT_FIGHTERS ]: 'effect-friend-from-work',
    [ EFFECT.GRANDMASTERS_CHAMPIONS ]: 'effect-armor-break',
    [ EFFECT.ELEMENTAL_HIDE ]: 'effect-elemental-hide',
    [ EFFECT.DARK_ILLUMINATI ]: 'effect-armor',
    [ EFFECT.ETERNAL_ADVERSARIES ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.HAIL_HYDRA ]: 'effect-heal-block',
    [ EFFECT.DARK_EMPOWERMENT ]: 'effect-spirit-of-justice',
    [ EFFECT.METAL_MAYHEM ]: 'effect-metal-mayhem',
    [ EFFECT.XASSASSINS ]: 'effect-xassassins',
    [ EFFECT.SEEING_RED ]: 'effect-seeing-red',
    [ EFFECT.DEADLY_PRESENCE ]: 'effect-deadly-presence',
    [ EFFECT.MEMORIES_OF_GENOSHA ]: 'effect-perfect-block',
    [ EFFECT.IMPENETRABLE_HIDE ]: 'type-mutant',
    [ EFFECT.ITS_COMPLICATED_2 ]: 'effect-power',
    [ EFFECT.PHOENIX_FORCE ]: 'effect-avengers-tryout',
    [ EFFECT.TOUGH_BRAWLERS ]: 'effect-unstoppable',
    [ EFFECT.PERSISTENT_FORCE ]: 'effect-believer',
    [ EFFECT.COMBO_FIGHTER ]: 'effect-attack',
    [ EFFECT.DAVID_AND_GOLIATH ]: 'effect-attack',
    [ EFFECT.COMBO_BREAKERS ]: 'effect-like-old-days',
    [ EFFECT.WARRIORS_OF_THE_STARS ]: 'effect-attack',
    [ EFFECT.FRIENDS ]: 'effect-critical-rate',
    [ EFFECT.SCHOOL_OF_HARD_ROCKS ]: 'effect-elemental-hide',
    [ EFFECT.WORTHY_OPPONENT ]: 'effect-worthy-opponent',
    [ EFFECT.UNENDING_AMBITION ]: 'effect-unending-ambition',
    [ EFFECT.MADCAP_EXPERIMENTALISTS ]: 'effect-health',
    [ EFFECT.TWISTED_ARCANISTS ]: 'effect-mercs-for-money',
    [ EFFECT.LEGION_ACCURSED ]: 'effect-unstoppable',
    [ EFFECT.GENETIC_RECODE_BARRIER ]: 'effect-genetic-recode-barrier',
    [ EFFECT.GENETIC_RECODE_SURVIVAL ]: 'effect-genetic-recode-survival',
    [ EFFECT.GENETIC_RECODE_HIVE_MIND ]: 'effect-shared-genetic-memory',
    [ EFFECT.GENETIC_RECODE_REGENESIS ]: 'effect-genetic-recode-regenesis',
    [ EFFECT.GENETIC_RECODE_EVOLUTION ]: 'effect-genetic-recode-evolution',
    [ EFFECT.GENETIC_RECODE_AGGRESSION ]: 'effect-xassassins',
    [ EFFECT.GENETIC_RECODE_PROBABILITY ]: 'effect-genetic-recode-probability',
    [ EFFECT.GENETIC_RECODE_BLOODLETTING ]: 'effect-genetic-recode-bloodletting',
    [ EFFECT.MYSTIC_MASTERS ]: 'type-mystic',
    [ EFFECT.ANCIENT_HUNGER ]: 'effect-spirit-of-justice',
    [ EFFECT.SUPREME_SYMBIOSIS ]: 'effect-spirit-of-justice',
    [ EFFECT.MIDNIGHT_PURSUIT ]: 'effect-bleed',
    [ EFFECT.JUSTICE_ON_WHEELS ]: 'effect-unstoppable',
    [ EFFECT.CONTEST_TEAMMATES ]: 'effect-contest-teammates',
    [ EFFECT.TACTICAL_TRAINING ]: 'effect-tactical-training',
    [ EFFECT.NIGHT_HAWKS ]: 'effect-night-hawks',
    [ EFFECT.DARK_JUSTICE ]: 'effect-critical-rate',
    [ EFFECT.BIRDS_OF_PREY ]: 'effect-electric-supercharge',
    [ EFFECT.RUNS_IN_THE_FAMILY ]: 'effect-runs-family',
    [ EFFECT.OLD_TEAMMATES ]: 'effect-shock',
    [ EFFECT.UNCANNY_AVENGERS ]: 'effect-perfect-block',
    [ EFFECT.GENETIC_MASTERPIECE ]: 'type-mutant',
    [ EFFECT.MUTANT_DOMINION ]: 'effect-tech-advancement',
    [ EFFECT.BLOOD_LINES ]: 'effect-critical-rate',
    [ EFFECT.MASTERMINDS_TWO ]: 'effect-power-lock',
    [ EFFECT.STOLEN_MEMORIES ]: 'effect-unstoppable',
    [ EFFECT.PARTNERS_IN_SHIELD ]: 'effect-partners-shield',
    [ EFFECT.MARVELOUS ]: 'effect-power',
    [ EFFECT.FAN_CLUB ]: 'effect-attack',
    [ EFFECT.RESTORATION_KIT ]: 'effect-health',
    [ EFFECT.STRATEGIC_SABOTAGE ]: 'effect-evade',
    [ EFFECT.INCREASED_FIREPOWER ]: 'effect-masters-of-the-sword',
    [ EFFECT.CONTINGENCY_PLAN ]: 'effect-contingency-plan',
    [ EFFECT.EXTREME_CONDITIONS_KIT ]: 'effect-advanced-idea-mechanics',
    [ EFFECT.POWER_KIT ]: 'effect-hell-lords',
    [ EFFECT.GWENOM_RISING ]: 'effect-shared-genetic-memory',
    [ EFFECT.AGENTS_OF_SMASH ]: 'effect-lullaby',
    [ EFFECT.HUNTRESS_OF_THE_CONTEST ]: 'effect-huntress-of-the-contest',
    [ EFFECT.SIBLING_RIVALRY ]: 'effect-inseparable',
    [ EFFECT.CYBERNETICS_UPGRADE_ASSAULT ]: 'effect-cybernetics-assault',
    [ EFFECT.CYBERNETICS_UPGRADE_TACTICS ]: 'effect-cybernetics-tactics',
    [ EFFECT.DOUBLE_NEGATIVE ]: 'effect-armor-break',
    [ EFFECT.CHALLENGER ]: 'effect-armor',
    [ EFFECT.RAIN_OF_FIRE ]: 'effect-mercs-for-money',
    [ EFFECT.TURN_UP_THE_HEAT ]: 'effect-mercs-for-money',
    [ EFFECT.A_SONG_OF_FIRE_AND_ICE ]: 'effect-shock',
    [ EFFECT.FAMILIAR_FACES ]: 'effect-inseparable',
    [ EFFECT.LAST_HOPE ]: 'effect-immunity-bleed',
    [ EFFECT.UNLIKELY_COMBINATION ]: 'effect-poison',
    [ EFFECT.LIVE_AND_DIE_BY_THE_SWORD ]: 'effect-masters-of-the-sword',
    [ EFFECT.MASTERLESS ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.LIEUTENANTS_OF_THE_BLACK_ORDER ]: 'effect-critical-rate',
    [ EFFECT.CULL_OF_THE_MAW ]: 'effect-attack',
    [ EFFECT.INVASIVE_FORCE ]: 'effect-invasive-force',
    [ EFFECT.DISPLAY_OF_STRENGTH ]: 'effect-invasive-force',
    [ EFFECT.HEROES_NEVER_LEARN ]: 'effect-friend-from-work',
    [ EFFECT.TIDE_TO_GO ]: 'effect-tide-to-go',
    [ EFFECT.KINGS_OF_THE_WORLD ]: 'effect-unstoppable',
    [ EFFECT.BEACH_BODS ]: 'effect-attack',
    [ EFFECT.FORCE_BLOCK ]: 'effect-perfect-block',
    [ EFFECT.TILL_DEATH ]: 'effect-till-death',
    [ EFFECT.UNPHASED ]: 'effect-hell-lords',
    [ EFFECT.ONE_WAY_OR_ANOTHER ]: 'effect-friend-from-work',
    [ EFFECT.STARK_INTERNSHIP ]: 'effect-mercs-for-money',
    [ EFFECT.SPIDERMEN_IN_BLACK ]: 'effect-spidermen-in-black',
    [ EFFECT.BAD_FOR_BUSINESS ]: 'effect-bad-for-business',
    [ EFFECT.CULTURE_SHOCK ]: 'effect-electric-supercharge',
    [ EFFECT.MINE_CAN_HOVER ]: 'effect-evade',
    [ EFFECT.ENCROACHING_INSANITY ]: 'effect-poison',
    [ EFFECT.ENHANCED_ILLUSIONIST ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.MENTAL_IMMUNITY ]: 'effect-mental-immunity',
    [ EFFECT.NEW_MUTANTS ]: 'effect-new-mutants',
    [ EFFECT.AIM_TECHNOLOGY ]: 'effect-time',
    [ EFFECT.LEADING_AVENGERS ]: 'effect-shield',
    [ EFFECT.SELFFRIENDS ]: 'effect-power-lock',
    [ EFFECT.ROBOT_UPRISING ]: 'effect-attack',
    [ EFFECT.GOING_VIRAL ]: 'effect-going-viral',
    [ EFFECT.FIRST_OF_HIS_NAME ]: 'effect-attack',
    [ EFFECT.DRY_ICE ]: 'effect-time',
    [ EFFECT.SENIORS_DISCOUNT ]: 'effect-power',
    [ EFFECT.JUDGEMENT_DAY ]: 'effect-time',
    [ EFFECT.A_SPELL_A_DAY_KEEPS_THE_DOCTOR_AWAY ]: 'effect-stun',
    [ EFFECT.FIRE_AND_FORGET ]: 'effect-fire-and-forget',
    [ EFFECT.SPIDERS_BITE ]: 'effect-spidermen-in-black',
    [ EFFECT.FEARSOME_FOUR ]: 'effect-believer',
    [ EFFECT.BANE_OF_EVIL ]: 'effect-attack',
    [ EFFECT.THINGS ]: 'effect-attack',
    [ EFFECT.MISUNDERSTOOD_MONSTERS ]: 'effect-poison',
    [ EFFECT.AI_UPRISING ]: 'effect-spirit-of-justice',
    [ EFFECT.OUR_SHARED_CURSE ]: 'effect-power',
    [ EFFECT.HUNTING_PARTY ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.BEAUTY_AND_THE_BEAST ]: 'effect-evade',
    [ EFFECT.FANTASTIC_RAGE ]: 'effect-nullify',
    [ EFFECT.ENHANCED_FORCEFIELD ]: 'effect-till-death',
    [ EFFECT.GENIUS_INGENUITY ]: 'effect-electric-supercharge',
    [ EFFECT.COSMIC_OVERLOAD ]: 'effect-cosmic-overload',
    [ EFFECT.SORCERY_REVERSAL ]: 'effect-sorcery-reversal',
    [ EFFECT.MYSTIC_TYRANTS ]: 'effect-mystic-tyrants',
    [ EFFECT.HERBIE ]: 'effect-regeneration',
    [ EFFECT.FANTASTIC_FOUR ]: 'effect-fantastic-four',
    [ EFFECT.DO_US_PART ]: 'effect-chronal-anchor',
    [ EFFECT.COLLEGE_RIVALS ]: 'effect-armor-break',
    [ EFFECT.SK_ASTRONOMY ]: 'effect-time',
    [ EFFECT.SK_ROBOTICS ]: 'effect-sk-robotics',
    [ EFFECT.SK_GENETICS ]: 'effect-power',
    [ EFFECT.HERALDS_OF_GALACTUS ]: 'effect-believer',
    [ EFFECT.SECRET_DEFENDERS ]: 'effect-time',
    [ EFFECT.MINE_TRAVELS_THROUGH_SPACE ]: 'effect-hell-lords',
    [ EFFECT.NEW_WARRIOR_BLOOD ]: 'effect-armor-break',
    [ EFFECT.TOTAL_ANNIHILATION ]: 'effect-resist-physical',
    [ EFFECT.MAXIMUM_OUTPUT ]: 'effect-shock',
    [ EFFECT.PHALANX_FEUD ]: 'effect-phalanx-feud',
    [ EFFECT.FULL_SPEED_AHEAD ]: 'effect-lullaby',
    [ EFFECT.SUPERNANNY ]: 'effect-attack',
    [ EFFECT.DEADPOOLS_GUIDE_TO_SUPER_VILLAINS ]: 'effect-deadpools-guide',
    [ EFFECT.HARDWIRED_FOR_HEARTBREAK ]: 'effect-electric-supercharge',
    [ EFFECT.BEAT_UP_THE_UNIVERSE ]: 'effect-lullaby',
    [ EFFECT.MOJOVERSE ]: 'effect-degeneration',
    [ EFFECT.SMILE_FOR_THE_CAMERAS ]: 'effect-power',
    [ EFFECT.WITHOUT_A_LEG_TO_STAND_ON ]: 'effect-mercs-for-money',
    [ EFFECT.CROWD_PLEASERS ]: 'effect-crowd-pleasers',
    [ EFFECT.CIVIL_WAR_STORIES ]: 'effect-civil-war-stories',
    [ EFFECT.LOVE_TRIANGLES ]: 'effect-love-triangles',
    [ EFFECT.PROBABLY_OP ]: 'effect-genetic-recode-probability',
    [ EFFECT.GOOD_VIBRATIONS ]: 'effect-bleed',
    [ EFFECT.MONSTER_MASH ]: 'effect-unstoppable',
    [ EFFECT.FANTASTIC_FIENDS ]: 'effect-stun',
    [ EFFECT.DEATH_AND_RESURRECTION ]: 'effect-hell-lords',
    [ EFFECT.ELDERS_GAME ]: 'effect-elders-game',
    [ EFFECT.PRISONER ]: 'effect-armor-break',
    [ EFFECT.A_GANG_OF ]: 'effect-idol',
    [ EFFECT.LAB_PARTNERS ]: 'effect-idol',
    [ EFFECT.TROPHY_CASE ]: 'effect-idol',
    [ EFFECT.CHAMPIONS_OF_BATTLEWORLD ]: 'effect-power',
    [ EFFECT.DOCTORS_STRANGE ]: 'special-2',
    [ EFFECT.MYSTIC_ARTS ]: 'effect-mystic-arts',
    [ EFFECT.BLUETIFUL_PEOPLE ]: 'effect-wakandan-insight',
    [ EFFECT.GAMMA_HORDE ]: 'effect-stun',
    [ EFFECT.HOUSE_OF_IRON ]: 'effect-armor-break',
    [ EFFECT.SETUP_AND_SPIKE ]: 'special-2',
    [ EFFECT.UNDER_THE_WEATHER ]: 'effect-time',
    [ EFFECT.KINGDOM_OF_WAKANDA ]: 'effect-bleed',
    [ EFFECT.SPIDERGUILD ]: 'effect-evade',
    [ EFFECT.FAMILY_REUNION ]: 'effect-lullaby',
    [ EFFECT.EASTERN_BLOCKERS ]: 'special-2',
    [ EFFECT.LIVING_STEEL_CURTAIN ]: 'effect-living-steel-curtain',
    [ EFFECT.MAGNIFICENT_MANES ]: 'effect-worthy-opponent',
    [ EFFECT.ENHANCED_WITH_CARBONADIUM ]: 'effect-enhanced-with-carbonadium',
    [ EFFECT.REMEMBER_ME ]: 'effect-remember-me',
    [ EFFECT.REMEMBERING_BUDAPEST ]: 'effect-immunity-bleed',
    [ EFFECT.COVERT_EXPERTISE ]: 'effect-critical-rate',
    [ EFFECT.WEST_COAST_AVENGERS ]: 'effect-poison',
    [ EFFECT.FELINE_POSSESSION ]: 'effect-nullify',
    [ EFFECT.ENTREE ]: 'effect-attack',
    [ EFFECT.BIG_GAME_HUNTERS ]: 'effect-time',
    [ EFFECT.NOT_THE_FACE ]: 'effect-bleed',
    [ EFFECT.SPIDER_MONKEY ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.FURRY_FRENEMIES ]: 'effect-armor-break',
    [ EFFECT.NO_EVIL ]: 'effect-critical-damage',
    [ EFFECT.ON_GUARD_FOR_THEE ]: 'effect-perfect-block',
    [ EFFECT.ALPHA_FLIGHT ]: 'effect-electric-supercharge',
    [ EFFECT.EXCAVATORS ]: 'effect-unstoppable',
    [ EFFECT.JUST_HAIR_AND_THINGS ]: 'effect-just-hair-and-things',
    [ EFFECT.GAMMA_RAY_RAY ]: 'effect-gamma-ray-ray',
    [ EFFECT.FURRY_BUDS ]: 'effect-time',
    [ EFFECT.GIANT_CHALLENGERS ]: 'effect-giant-challengers',
    [ EFFECT.COMMON_HISTORY ]: 'effect-common-history',
    [ EFFECT.NOVA_CORPS_VETERANS ]: 'effect-attack',
    [ EFFECT.THE_HIGH_GROUND ]: 'effect-time',
    [ EFFECT.THE_FIRST_ONE ]: 'effect-attack',
    [ EFFECT.BRINGER_OF_DEATH_I ]: 'effect-spirit-of-justice',
    [ EFFECT.BRINGER_OF_DEATH_II ]: 'effect-living-steel-curtain',
    [ EFFECT.BRINGER_OF_DEATH_III ]: 'effect-contest-teammates',
    [ EFFECT.BRINGER_OF_DEATH_IV ]: 'effect-gamma-ray-ray',
    [ EFFECT.GUARDIAN_OF_THE_PYRAMID ]: 'effect-mostly-average-joes',
    [ EFFECT.IMPENDING_STORM ]: 'effect-electric-supercharge',
    [ EFFECT.YOUR_FATE_IS_MINE ]: 'effect-degeneration',
    [ EFFECT.CHAOTIC_ENERGY ]: 'effect-chaotic-energy',
    [ EFFECT.CROSSOVER ]: 'effect-crossover',
    [ EFFECT.DEATHWISH ]: 'effect-deathwish',
    [ EFFECT.GOODFELLA ]: 'effect-goodfella',
    [ EFFECT.MERC_WITH_A_MOUTH ]: 'effect-contest-teammates',
    [ EFFECT.STUCK_IN_LIMBO ]: 'effect-contingency-plan',
    [ EFFECT.DRUG_I ]: 'effect-drug-i',
    [ EFFECT.DRUG_L ]: 'effect-drug-l',
    [ EFFECT.DRUG_M ]: 'effect-drug-m',
    [ EFFECT.GATEWAY ]: 'effect-gateway',
    [ EFFECT.HABITAT ]: 'effect-habitat',
    [ EFFECT.FIRST_CRUSH ]: 'effect-huntress-of-the-contest',
    [ EFFECT.FULL_METAL ]: 'effect-power',
    [ EFFECT.NOT_SO_HIDDEN_DRAGON ]: 'effect-mostly-average-joes',
    [ EFFECT.STUDENT_LOANS ]: 'effect-student-loans',
    [ EFFECT.MY_BROTHERHOOD ]: 'effect-my-brotherhood',
    [ EFFECT.MY_CONTEST_NOW ]: 'effect-my-contest-now',
    [ EFFECT.MY_HELLFIRE_CLUB ]: 'effect-mercs-for-money',
    [ EFFECT.MY_METALLIC_ANTIPATHY ]: 'effect-metallic',
    [ EFFECT.METALLIC_AFFINITY ]: 'effect-metallic',
    [ EFFECT.REDEMPTION ]: 'effect-redemption',
    [ EFFECT.RISE_AGAINST_THE_CONTEST ]: 'type-skill',
    [ EFFECT.FAMILY_FEUD ]: 'effect-time',
    [ EFFECT.HATRED ]: 'effect-armor-break',
    [ EFFECT.OSBORN_TO_BE_WILD ]: 'effect-phalanx-feud',
    [ EFFECT.SELF_CENTERED ]: 'effect-attack',
    [ EFFECT.SYMBIOTE_CONSCIOUSNESS ]: 'effect-critical-damage',
    [ EFFECT.COSMIC_BANE_OF_EVIL ]: 'effect-phalanx-feud',
    [ EFFECT.COSMIC_JUSTICE_ON_WHEELS ]: 'effect-armor-break',
    [ EFFECT.PUNISHMENTS_OF_INFINITE_VARIETY ]: 'effect-critical-damage',
    [ EFFECT.SPIRITS_OF_VENGEANCE ]: 'effect-attack',
    [ EFFECT.FASTBALL_SPECIAL ]: 'effect-unstoppable',
    [ EFFECT.FEEL_CYTORAKS_EMBRACE ]: 'effect-overcoming-fear',
    [ EFFECT.DONT_MENTION_PUNY_BANNER ]: 'effect-lullaby',
    [ EFFECT.TECHNOLOGICAL_COMPETITION ]: 'effect-gamma-ray-ray',
    [ EFFECT.ENGINEERING_EXPERTS ]: 'effect-enhanced-with-carbonadium',
    [ EFFECT.IT_AINT_EASY ]: 'effect-wakandan-insight',
    [ EFFECT.SINGULARITY ]: 'effect-critical-damage',
    [ EFFECT.ENHANCED_ADAMANTIUM ]: 'effect-enhanced-with-carbonadium',
    [ EFFECT.NO_NOT_YOU ]: 'effect-degeneration',
    [ EFFECT.THE_BRAVE_AND_THE_BOULDER ]: 'effect-attack',
    [ EFFECT.PASSIVE_AGGRESSIVE ]: 'effect-elemental-hide',
    [ EFFECT.ARACHNID_HUNTERS ]: 'effect-seething-hatred',
    [ EFFECT.ALPHA_FLIGHT_SPACE_STATION ]: 'effect-chronal-anchor',
    [ EFFECT.GAMMA_MUTATES ]: 'effect-health',
    [ EFFECT.EXTREME_MEASURES ]: 'effect-stun',
    [ EFFECT.HELL_AND_BACK ]: 'effect-particle-physics',
    [ EFFECT.FAIREST_OF_THEM_ALL ]: 'effect-worthy-opponent',
    [ EFFECT.ABOMINABLE_COMRADE ]: 'effect-poison',
    [ EFFECT.IMMORTAL_RULERS ]: 'effect-xassassins',
    [ EFFECT.IMMORTAL_KINGS ]: 'effect-giant-challengers',
    [ EFFECT.TWO_DAYS_THIRTY_YEARS ]: 'effect-two-days-thirty-years',
    [ EFFECT.SATURDAY_MORNING_CARTOONS ]: 'effect-poison',
    [ EFFECT.SWINESTER_SIX_MOST_WANTED ]: 'effect-swinester-six-most-wanted',
    [ EFFECT.FOURTH_WALL_CRAWLER ]: 'effect-fourth-wall-crawler',
    [ EFFECT.FISK_DOWNFALL ]: 'effect-bane-of-hells-kitchen',
    [ EFFECT.SECRET_OF_THE_HAND ]: 'effect-secret-of-the-hand',
    [ EFFECT.RULE_OF_LAW ]: 'effect-stun',
    [ EFFECT.STRENGTH_OF_MARTYRS ]: 'effect-soul-seeker',
    [ EFFECT.ALL_ADAMANTIUM_AND_ATTITUDE ]: 'effect-attack',
    [ EFFECT.DEAL_WITH_IT ]: 'effect-health',
    [ EFFECT.EXECUTE_TARGET_ACQUISITION_SUBROUTINE ]: 'effect-power-lock',
    [ EFFECT.PETITE ]: 'effect-mostly-average-joes',
    [ EFFECT.THE_LUCKY_ONE ]: 'effect-mental-immunity',
    [ EFFECT.YOURE_TANGLING_WITH_THE_WRONG_XMEN ]: 'effect-resist-energy',
    [ EFFECT.BIG_BAD_DAD ]: 'effect-cybernetics-tactics',
    [ EFFECT.BULL_TARGETS ]: 'effect-attack',
    [ EFFECT.CLONED_AT_BIRTH ]: 'effect-fourth-wall-crawler',
    [ EFFECT.MISS_ME ]: 'effect-mental-immunity',
    [ EFFECT.HOSTILE_TAKEOVER ]: 'effect-armor-break',
    [ EFFECT.WEDDING_CRASHER ]: 'effect-fourth-wall-crawler',
    [ EFFECT.DINKY_SHRINKS ]: 'effect-block',
    [ EFFECT.MALICE ]: 'effect-huntress-of-the-contest',
    [ EFFECT.PURE_HATRED ]: 'effect-attack',
    [ EFFECT.THERE_GOES_THE_MULTIVERSE ]: 'effect-stun',
    [ EFFECT.POWER_OF_MONEY ]: 'effect-heroes-for-hire',
    [ EFFECT.REVOLUTIONS_NEED_ARMS ]: 'effect-xassassins',
    [ EFFECT.AMBER_PRISON ]: 'effect-hell-lords',
    [ EFFECT.BANISHED ]: 'effect-attack',
    [ EFFECT.ENERGY_ABSORPTION ]: 'effect-resist-energy',
    [ EFFECT.FUELED_WITH_RAGE ]: 'effect-huntress-of-the-contest',
    [ EFFECT.RAGE_ON ]: 'effect-power-lock',
    [ EFFECT.BATTLE_OF_REALMS ]: 'effect-attack',
    [ EFFECT.OATHSWORN ]: 'effect-perfect-block',
    [ EFFECT.ODINSONS_AND_ODINSDOTTIRS ]: 'effect-friend-from-work',
    [ EFFECT.WARMONGER ]: 'effect-attack',
    [ EFFECT.HYDRA_RECRUITERS ]: 'effect-nullify',
    [ EFFECT.MERCENARY_COMPETITION ]: 'effect-heroes-for-hire',
    [ EFFECT.CONTEMPTUOUS_HATRED ]: 'effect-bad-for-business',
    [ EFFECT.WE_AINT_NO_PUNCHLINE ]: 'effect-swinester-six-most-wanted',
    [ EFFECT.NEW_YORK_BRAWLERS ]: 'effect-attack',
    [ EFFECT.NOT_SO_UNCANNY ]: 'effect-mutant-agenda',
    [ EFFECT.IRON_MEN ]: 'effect-incinerate',
    [ EFFECT.ASGARDIAN_REPUBLIC ]: 'effect-shock',
    [ EFFECT.PATRIOT_GARRISON ]: 'effect-unstoppable',
    [ EFFECT.PET_PALS ]: 'effect-cybernetics-tactics',
    [ EFFECT.HUNTRESSES ]: 'effect-attack',
    [ EFFECT.PYRAMID_X ]: 'effect-critical-rate',
    [ EFFECT.TEMPLE_OF_VISHANTI ]: 'effect-power-lock',
    [ EFFECT.TRIBAL_WARFARE ]: 'effect-attack',
    [ EFFECT.EYES_OF_THE_DRAGON ]: 'effect-critical-rate',
    [ EFFECT.MASTER_MARTIAL_ARTISTS ]: 'effect-stun',
    [ EFFECT.SHADOWLAND ]: 'effect-degeneration',
    [ EFFECT.THE_WAY_OF_THE_SPIDER ]: 'effect-attack',
    [ EFFECT.A_BEING_DARKER_THAN_I ]: 'effect-friend-from-work',
    [ EFFECT.FROM_LIGHT_TO_DARK ]: 'effect-seething-hatred',
    [ EFFECT.HEALING_TOUCH ]: 'effect-regeneration',
    [ EFFECT.TIME_WE_CHANGED_TOO ]: 'effect-resist-energy',
    [ EFFECT.BATTLEREALMS_CHANGING ]: 'effect-gamma-ray-ray',
    [ EFFECT.KINGS ]: 'effect-attack',
    [ EFFECT.ROYALS ]: 'effect-mostly-average-joes',
    [ EFFECT.WARRIORS ]: 'effect-attack',
    [ EFFECT.DIMENSIONAL_BUDDIES ]: 'effect-heightened-senses',
    [ EFFECT.MANY_AS_ONE ]: 'effect-regeneration',
    [ EFFECT.POOR_UNFORTUNATE_SOUL ]: 'effect-poor-unfortunate-soul',
    [ EFFECT.QUEENS_OF_SOULS ]: 'effect-prowess',
    [ EFFECT.UNCHAINED ]: 'effect-bad-for-business',
    [ EFFECT.WHAT_IF ]: 'effect-incinerate',
    [ EFFECT.COSMIC_CONTROL ]: 'effect-unstoppable',
    [ EFFECT.CUBE_WIELDERS ]: 'effect-particle-physics',
    [ EFFECT.IDENTITY_DISORDER ]: 'effect-mental-immunity',
    [ EFFECT.SHIELD_BUDDIES ]: 'effect-block',
    [ EFFECT.SPACE_SURFERS ]: 'effect-critical-rate',
    [ EFFECT.FORTIFY_ENHANCEMENT ]: 'effect-block',
    [ EFFECT.SKIRMISH_ENHANCEMENT ]: 'effect-electric-supercharge',
    [ EFFECT.SUPPORT_ENHANCEMENT ]: 'effect-attack',
    [ EFFECT.MY_BEAUTIFUL_METEOR ]: 'effect-attack',
    [ EFFECT.MY_WORLD_OF_METAL ]: 'effect-common-history',
    [ EFFECT.DECIMATION_SW ]: 'effect-time',
    [ EFFECT.CHAOS_RISING ]: 'effect-genetic-recode-probability',
    [ EFFECT.TILL_INFINITY_DO_US_PART ]: 'effect-phalanx-feud',
    [ EFFECT.DEMONIC_PACT ]: 'effect-regeneration',
    [ EFFECT.SUPER_STARS ]: 'effect-student-loans',
    [ EFFECT.OUT_OF_THIS_WORLD ]: 'effect-sorcery-reversal',
    [ EFFECT.STAY_POSITIVE ]: 'effect-power-lock',
    [ EFFECT.KO_QUEENS ]: 'effect-prowess',
    [ EFFECT.NEXT_ROUND_ON_ME ]: 'effect-gamma-ray-ray',
    [ EFFECT.MASTERFUL_COMBAT ]: 'effect-prowess',
    [ EFFECT.ARM_WRESTLING_CLUB ]: 'effect-attack',
    [ EFFECT.PAWN_SET_FREE ]: 'effect-cybernetics-tactics',
    [ EFFECT.INCREDIBLE_SUBSTITUTE ]: 'effect-friend-from-work',
    [ EFFECT.I_REQUIRE_THY_SHIELD ]: 'effect-armor-break',
    [ EFFECT.START_WITH_FRESH_DEADPOOL ]: 'effect-regeneration',
    [ EFFECT.ACCURATELY_MEASURE_INGREDIENTS ]: 'effect-critical-rate',
    [ EFFECT.BLEND_IN_SYMBIOTE ]: 'effect-shared-genetic-memory',
    [ EFFECT.ADD_PLAIN_WHITE_FLOUR ]: 'effect-advanced-idea-mechanics',
    [ EFFECT.FRY_IN_SKILLET ]: 'effect-incinerate',
    [ EFFECT.ADJUST_COOKING_TIMER ]: 'effect-time',
    [ EFFECT.ALLOW_TO_COOL ]: 'effect-my-contest-now',
    [ EFFECT.MUNCH_STUNNING_FOOD ]: 'effect-stun',
    [ EFFECT.NOT_THE_HERO ]: 'effect-redemption',
    [ EFFECT.BUT_THE_BEST_VILLAIN ]: 'effect-bad-for-business',
    [ EFFECT.CRIME_BOSSES ]: 'effect-wakandan-insight',
    [ EFFECT.CONTEMPTUOUS_MALICE ]: 'effect-attack',
    [ EFFECT.GIANT_MONSTROSITIES ]: 'effect-attack',
    [ EFFECT.ANGEL_ATTACK ]: 'effect-block',
    [ EFFECT.FIELD_TRIP ]: 'effect-block',
    [ EFFECT.SPIDERGEDDON ]: 'effect-shared-genetic-memory',
    [ EFFECT.STRANGE_BEASTS_AND_BIZARRE_MACHINES ]: 'effect-living-steel-curtain',
    [ EFFECT.SUIT_UP ]: 'effect-health',
    [ EFFECT.TECHNICIAN ]: 'effect-friend-from-work',
    [ EFFECT.AI_ENTHUSIASTS ]: 'effect-shared-genetic-memory',
    [ EFFECT.COWORKERS ]: 'effect-critical-rate',
    [ EFFECT.SPIDERVERSE_VETERANS ]: 'effect-evade',
    [ EFFECT.SYMBIOTE_PROBLEMS ]: 'effect-poison',
    [ EFFECT.WE_ARE_MANY ]: 'effect-attack',
    [ EFFECT.ADVANCED_INTELLIGENCE ]: 'effect-genetic-recode-probability',
    // [ EFFECT.NEW_WAVE ]: 'effect-incinerate',
    [ EFFECT.RESISTANCE_IS_FUTILE ]: 'effect-armor',
    [ EFFECT.TERMINATED ]: 'effect-prowess',
    [ EFFECT.FIRE_AND_DRAGONS ]: 'effect-incinerate',
    [ EFFECT.JUST_A_PHASE ]: 'effect-miss',
    [ EFFECT.SHADOWY_HISTORY ]: 'effect-shock',
    [ EFFECT.THROUGH_THICK_AND_THIN ]: 'effect-attack',
    [ EFFECT.VICIOUS_KITTY ]: 'effect-genetic-recode-bloodletting',
    [ EFFECT.WORTH_A_SHOT ]: 'effect-attack',
    [ EFFECT.SPIDERSENSES_TINGLING ]: 'effect-spidermen-in-black',
    [ EFFECT.SPIDERVERSE_MENTORS ]: 'effect-seething-hatred',
    [ EFFECT.CYBERNETICS_UPGRADE_BLITZ ]: 'effect-attack',
};

function effectIcon(uid) {
    return effectIcons[ uid ] || 'circle';
}

const effectBases = effects.reduce((map, { attr }) => {
    map[ attr.uid ] = attr.base;
    return map;
}, {});
function effectBase(uid) {
    return effectBases[ uid ] || 1000;
}

export { effectIcon, effectBase };
export default effects;



// WEBPACK FOOTER //
// ./src/data/effects.js